// Ajax settings
$.mobile.buttonMarkup.hoverDelay = 0;
$.mobile.defaultPageTransition = "none";
$.mobile.defaultDialogTransition = "none";
$.ajaxSetup({cache: false});
$.ajaxSetup({timeout: 15000});
connection = false;

// Funkcia sluzi na odchytenie a zalogovanie explicitne neodchytenych vynimiek
window.onerror = function (msg, url, lineNo, columnNo, error) {
    main.createLog(2, "logUncaughtExceptions", "msg: " + msg + " url: " + url + " lineNo: " + lineNo + " columnNo: " + columnNo + " # ERROR: " + JSON.stringify(error));
    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
    return false;
};

// Funkcia registruje custom prototype funkcie
(function registerPrototypes() {
    // Funkcia sluzi na vymenu prvkov v poli
    Array.prototype.arrayMove = function(from, to) {
        try {
            if (typeof from == "number" && typeof to == "number") {
                var element = this[from];
                this.splice(from, 1);
                this.splice(to, 0, element);
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }

    // Deep merge "updates" do "current" pola
    merge = function(current, updates) {
        try {
            if (typeof current == "object" && typeof updates == "object") {
                for (key of Object.keys(updates)) {
                    if (!current.hasOwnProperty(key) || typeof updates[key] !== 'object') current[key] = updates[key];
                    else merge(current[key], updates[key]);
                };
                return current;
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }

    // Funkcia prechadza pole objektov a zgrupuje ich podla prop
    Array.prototype.groupBy = function(prop, emptyDisable) {
        try {
            if (typeof this == "object" && typeof this.includes == "function") {
                return this.reduce(function (acc, obj) {
                    var key = obj[prop];
                    if (emptyDisable && !!key) {
                        // Odstrani prazdne property
                        if (!acc[key]) {
                            acc[key] = [];
                        }
                        acc[key].push(obj);
                    }
                    return acc;
                }, {});
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }

    // Funkcia vrati rozdielove polozky pola
    Array.prototype.diff = function(arrayToDiff) {
        try {
            if (typeof this == "object" && typeof this.includes == "function") {
                return this.filter(function(t) {
                    return !arrayToDiff.includes(t);
                });
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }

    // Funkcia vrati prienikove polozky pola
    Array.prototype.interSection = function(arrayToInterSection) {
        try {
            if (typeof this == "object" && typeof this.includes == "function") {
                return this.filter(function(t) {
                    return arrayToInterSection.includes(t);
                });
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }

    // Funkcia na zistenie ci je cislo v rozmedzi min a max
    Number.prototype.timeInRange = function(min, max) {
        try {
            if (typeof min == "number" && typeof max == "number") {
                return (this - min) * (this - max) <= 0;
            }
        } catch(e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    }

    // Funkcia kontroluje ci 't' argument nie je definovany, ak ano vrati 'replacement'
    String.prototype.noValueCheck = function(t, replacement) {
        typeof t !== 'undefined'? t : t = replacement;
        return t;
    }
})();

// START po nacitani aplikacie
$(function () {
    main.lockApp(-1, "LOADING ..");
    // MAIN SETTINGS - START APP na konci inicializacie nastaveni
    setTimeout(function () {
        $("head").append('<script type="text/javascript" src="settings/sportbox-app.min.js"></script>');

        // BASE URL
        url = new Object();
        url.base = window.location.href.split("#")[0];
        url.country = window.location.hostname.split(".")[window.location.hostname.split(".").length -1];
        if (!url.country || sets.hostnames.includes(window.location.hostname)) url.country = "sk";
        if (window.location.href != url.base) {
            window.location.href = url.base;
        }

        // STATIC URL
        url.static = "https://static.doxxbet." + url.country;

        // STATIC CDN URL Sport Repo: https://repository.codium.sk/doxxbet/static/sport-asset
        url.assetSport = "https://asset-sport.cdn.doxxbet.sk/";

        // STATIC CDN URL Region Repo: https://repository.codium.sk/doxxbet/static/region-asset
        url.assetRegion = "https://asset-region.cdn.doxxbet.sk/";

        // STATIC CDN URL Team Repo: https://repository.codium.sk/doxxbet/static/team-asset
        url.assetTeam = "https://asset-team.cdn.doxxbet.sk/medium/";

        // STATIC CDN URL Sport - default pozadie v event detaile
        url.assetSportDefaultBG ="url(" + url.assetSport + "backgrounds/wide/sport_0.jpg)";

    }, 0);
    ticketStatusSection = $("#ticketStatus #section").html().toString().replace(/  +/g, " ");
});

// Kontrola nepovoleho posunu po stranke
$(window).bind("hashchange", function () {
    try {
        clearTimeout(ct.checkURL); 
        ct.checkURL = setTimeout(function () {
            if (window.location.hash != url.location) {
                window.location = url.base;
            }
        }, sets.darkScreen);
    } catch(e) { 
        console.error(e);
    }
});

// Zablokuje hover
$("*").bind("mouseover", function () {
    return false;
});

// Transparentne dialogove okno - pagebeforeshow
$('div[data-role="dialog"]').live('pagebeforeshow', function (e, ui) {
    ui.prevPage.addClass("ui-dialog-background");
    setTimeout(function () {
        url.location = window.location.hash;
    }, 0);
});

// Transparentne dialogove okno - pagehide
$('div[data-role="dialog"]').live('pagehide', function () {
    $(".ui-dialog-background").removeClass("ui-dialog-background");
    url.location = "";
});

// Kontrola uzivatelskej aktivity na SB
document.addEventListener("pointerdown", function () {
    main.userAction(true);
    try {
        if (typeof WebAppUserActivity === "function") { 
            // Pouziva sa pri zobrazeni dokumentov pocas onboardingu aby nativeApp vedela ze uzivatel tuka a nedoslo pocas zobrazovania ku chybe, ak doslo k chybe, tak nativeApp reloadne webApp
            WebAppUserActivity(true);
        }
        // Pouziva screenApp aby po necinnosti hraca vypla vsetky spustene media, sluzi ako poistka
        communication.topScreen("watcher", {time: Date()});
        console.log("%c watcher called, watcher [s]: " + profile.MediaDisableProtectionTime/1000, "background:tomato;padding:5px;color:white;");
    } catch (e) {
        console.info("ERROR catched in function: " + main.catchFunctionCall(arguments));
    }
});

// Plugin na prednostne zaregistrovanie vlastnych event funkcii pred jQuery mobile default funkciami
// $(element).bindFirst('click', function(){...})
(function registerEventBeforeJquery() {
    (function ($) {
        var splitVersion = $.fn.jquery.split(".");
        var major = parseInt(splitVersion[0]);
        var minor = parseInt(splitVersion[1]);

        var JQ_LT_17 = (major < 1) || (major == 1 && minor < 7);

        function eventsData($el) {
            return JQ_LT_17 ? $el.data('events') : $._data($el[0]).events;
        }

        function moveHandlerToTop($el, eventName, isDelegated) {
            var data = eventsData($el);
            var events = data[eventName];

            if (!JQ_LT_17) {
                var handler = isDelegated ? events.splice(events.delegateCount - 1, 1)[0] : events.pop();
                events.splice(isDelegated ? 0 : (events.delegateCount || 0), 0, handler);
                return;
            }

            if (isDelegated) {
                data.live.unshift(data.live.pop());
            } else {
                events.unshift(events.pop());
            }
        }

        function moveEventHandlers($elems, eventsString, isDelegate) {
            var events = eventsString.split(/\s+/);
            $elems.each(function () {
                for (var i = 0; i < events.length; ++i) {
                    var pureEventName = $.trim(events[i]).match(/[^\.]+/i)[0];
                    moveHandlerToTop($(this), pureEventName, isDelegate);
                }
            });
        }

        function makeMethod(methodName) {
            $.fn[methodName + 'First'] = function () {
                var args = $.makeArray(arguments);
                var eventsString = args.shift();

                if (eventsString) {
                    $.fn[methodName].apply(this, arguments);
                    moveEventHandlers(this, eventsString);
                }
                return this;
            }
        }
        // bind
        makeMethod('bind');
        // one
        makeMethod('one');
        // delegate
        $.fn.delegateFirst = function () {
            var args = $.makeArray(arguments);
            var eventsString = args[1];

            if (eventsString) {
                args.splice(0, 2);
                $.fn.delegate.apply(this, arguments);
                moveEventHandlers(this, eventsString, true);
            }
            return this;
        };

        // live
        $.fn.liveFirst = function () {
            var args = $.makeArray(arguments);

            // live = delegate to the document
            args.unshift(this.selector);
            $.fn.delegateFirst.apply($(document), args);
            return this;
        };

        // on (jquery >= 1.7)
        if (!JQ_LT_17) {
            $.fn.onFirst = function (types, selector) {
                var $el = $(this);
                var isDelegated = typeof selector === 'string';

                $.fn.on.apply($el, arguments);

                // events map
                if (typeof types === 'object') {
                    for (type in types)
                        if (types.hasOwnProperty(type)) {
                            moveEventHandlers($el, type, isDelegated);
                        }
                } else if (typeof types === 'string') {
                    moveEventHandlers($el, types, isDelegated);
                }
                return $el;
            };
        }

    })(jQuery);
})();

main = {
    // Nastavenie jednotlivych URL na dane sluzby (offer, results, signalR, ticket, stats, betRadarStats)
    setURLs: function() {
        try {
            var countryFeed = offer.country;
            if (profile.CountryFeed) {
                countryFeed = profile.CountryFeed + "-" + offer.country;
            }

            if (profile.OddsCacheFeed) {
                // OFFER SERVICE URL Refactored cache (SSL)
                url.offer = "https://offer-oddscache-" + (profile.OddsCacheFeedCountryFeed? profile.OddsCacheFeedCountryFeed + "-": "") + "cf.doxxbet.sk:8401/ActualOfferService.svc/";
            } else {
                // OFFER SERVICE URL (SSL)
                url.offer = "https://offer-" + offer.platform + "-" + countryFeed + "-cf.doxxbet.sk:8401/ActualOfferService.svc/";
            }

            // OFFER SERVICE URL (SSL)
            url.results = "https://results-" + offer.platform + "-" + countryFeed + "-cf.doxxbet.sk:8404/ResultsService.svc/";

            // OFFER SIGNALR HUB URL
            url.signalR = "https://offer-signalr-" + offer.platform + "-" + offer.country.toLowerCase() + ".doxxbet.sk/signalr";
            // url.signalR = "https://offer-hub-" + offer.level + "-" + offer.country + ".doxxbet.sk";

            // TICKET URL (SSL)
            url.ticket = "https://ticket-" + offer.country + ".doxxbet.sk:8401/Ticket.svc/";

            // CENTRAL SPORTBOX URL
            url.centralSB = "https://central-sportbox-" + offer.country + ".doxxbet.sk:8420/" + offer.platform;

            // CENTRAL SPORTBOX URL PUBLIC (s tokenom)
            url.centralSBAuth = url.centralSB + "/ac";

            // STATS URL (SSL)
            url.stats = "https://statistics-cf.doxxbet.sk/statistics/";

            // BETRADAR STATS URL
            url.betRadarStats = "https://s5.sir.sportradar.com/doxxbetm/";

            // [Betbuilder Aggregator API] URL
            url.betbuilderAgg = profile.BetBuilderAggProxy;


            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia zabezpecujuca jednotlive kroky pri spusteni aplikacie aplikacie
    startApp: function(step) {
        try {
            switch (step) {
                case 1:
                    // Restart app
                    if (ct.initWebApp != 1) {
                        setTimeout(function () {
                            window.location = url.base;
                        }, 1000);
                        return false;
                    }
                    // Inicializacia na nativeApp s ocakavanou odpovedou InitializeWebApp() -> setInitializeWebApp() (#1)
                    main.initWebAppCheck();
                    break;
                case 2:
                    // Kontrola funkcnosti aplikacie pre nativeApp
                    main.setHeartBeat();
                    // Deaktivacia RightClick pre SB
                    $(document).bind("contextmenu", function (e) {
                        return false;
                    });
                    break;
                case 3:
                    // Nastavenie pre ponuku a tiket (#4, #5)
                    main.setConfig();
                    break;
                case 4:
                    // Kompilacia direktiv (#7)
                    if (profile.ExtendedOffer && profile.FlatCSS) {
                        stored.ExtendedActualOffer = true;
                        $('#sportBox .content-table').parent().removeClass('is-fat-menu').addClass('is-narrow-menu');
                        directives.eventsDirective.events();
                        directives.eventsDirective.eventsSexta();
                    } else {
                        stored.ExtendedActualOffer = false;
                        directives.eventsDirective.events();
                    }
                    if (profile.UserSettingsSections.length) {
                        if (profile.UserSettingsSections.includes("localisation")) $('#userSettingsLocalisation').show();
                        if (profile.Favorite && profile.UserSettingsSections.includes("favorite")) $('#userSettingsFavorite').show();
                        if (profile.UserSettingsSections.includes("ticket")) $('#userSettingsTicket').show();
                        if (profile.UserSettingsSections.includes("notify")) $('#userSettingsNotify').show();
                    }
                    directives.topTipsDirective.topTips();
                    directives.eventsDirective.eventsVictoria();
                    if (profile.VirtualsStructureProviders) {
                        directives.virtualSportsbookDirective.sportsBookVG();
                    } else {
                        // Pouzije iny template pre lave menu virtualnych hier
                        $("#sportsBookVG").empty().append($("#sportsBookVG_template #sportVG"));
                        directives.virtualSportsbookDirective.sportsBookVGNoProviders();
                    }
                    directives.eventDetailDirective.eventDetail();
                    directives.ticketDetailDirective.ticketStatus();
                    directives.ticketDetailDirective.ticketStatusOdds();
                    directives.ticketDetailDirective.ticketStatusCombi();
                    directives.ticketDetailDirective.ticketStatusEditHistory();
                    // Dlazdica s bonusmi a k nim podstranky
                    if (profile.Bonuses) {
                        directives.playerBonusDirective.playerBonusesMenu();
                        if (profile.bonusList && (bonusList = JSON.parse(profile.BonusList))) {
                            more.menu.assignBonusData(JSON.parse(profile.TileInfo), bonusList);
                        } else {
                            // ak neexistuje bonusList, vyziada ho
                            more.menu.getBonusList(JSON.parse(profile.TileInfo));
                        }
                        // Zaregistrovanie iframe listenera nad bonus detailom (jednorazovo)
                        player.playerBonusModule.listenBonusDetailIframe();
                        directives.playerBonusDirective.playerBonusesFreebetList();
                        // playerBonusesActivatingBonus();
                    }
                    if (profile.FlatCSS && profile.MyTickets.length) directives.playerTicketsDirective.myTickets();
                    if (profile.LotteryAllowed) {
                        // Odchyenie akcie hraca v iframe loteriovych hier
                        lottery.listenGameIframe();
                        // Direktiva pre loteriove hry
                        directives.lotterySportsbookDirective.sportsBookLG();
                    }

                    // Posledna faza spustenia webAplikacie (#8)
                    main.startApp(5);
                    break;
                case 5:
                    // Hodiny
                    if (profile.OddsCacheFeed) {
                        main.setClockOddsCache();
                    } else {
                        main.setClock();
                    }
                    // Spusti sledovanie neaktivity (bez pripojenia na signalR hub)
                    main.userAction();
                    // Nacitanie uvodnej obrazovky (#9)
                    main.setPage(profile.startPage);
                    main.startPageRefresh(true);
                    // Zavola TopScreen
                    communication.topScreen("restart");
                    // Nacita len potrebne pridavne kniznice
                    main.loadAdditionalScripts();
                    // Obmedzenia pri pomalom/fup pripojeni
                    main.connectionRestrictions();
                    // Informuje nativeApp ze inicializacia webApp prebehla uspesne (potrebne v nativeApp pri zmene jazyka)
                    if (!stored.browser) ActionWebAppInitSuccess();
                    // Scroll pomocou potiahnutia prsta
                    shared.scrollModule.scrollOnTapAndHold("ticket");
                    // Ak bol SB zamknuty nativnou App tak sa odomkne (#10 - END)
                    main.createLog(0, "ConnectionOK");
                    // Ak je povolený zvuk, zobrazím ovládanie hlasitosti a nastavím hlasitosť na 0   
                    if (profile.HaveSound) {
                        $("#setVolumeToggle").show();
                        more.volume.setVolume(0);
                    } else {
                        $("#setVolumeToggle").hide();
                    }
                    break;

                default:
                    // Rucne spustenie cez web-browser
                    if (!stored.browser) {
                        $("head").append('<script type="text/javascript" src="settings/sportbox-browser.js"></script>');
                        $("body").addClass("browser");

                        // Osetri country na upperCase
                        offer.country = offer.country.toUpperCase();

                        // Nastavi iny jazyk
                        if (step) {
                            if (sets.extraResolutions.includes(step)) {
                                $("body").addClass("resolution-" + step);
                                profile.Resolution = step;
                            } else {
                                offer.lang = step;
                            }
                        }
                        main.requestTranslations();
                    } else {

                        // Restart app
                        setTimeout(function () {
                            window.location = url.base;
                        }, 500);
                        return false;
                    }
                    break;
            }
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            setTimeout(function () {
                window.location = url.base;
            }, 5000);
            return false;
        }
    },

    // Vyziadanie prekladov
    requestTranslations: function(lang) {
        // Stiahne texty zo servera
        var requestUrl;
        $.getJSON(requestUrl = "https://sbadmin-" + offer.country + ".doxxbet.sk/api/TranslationApi/GetUserTranslations/" + (lang? lang: offer.lang))
            .done(function (staticTexts) {
                if (staticTexts) {
                    if (!lang) {
                        // Browser prejde na inicializaciu
                        main.setInitializeWebApp(JSON.stringify({UserTranslations: staticTexts}));
                        // Vypne watcher
                        clearTimeout(rfs.watcher);
                        // Ak sa jedna o lokalne spustanu app a nie retail otvori screens app
                        if (stored.browser && !profile.IsRetail) {
                            try {
                                // Appendovanie scriptu tymto sposobom spristupni debug v sources - devtools 
                                var script = document.createElement('script');
                                script.src = 'settings/top-screen-comm.js';
                                document.head.appendChild(script);
                            } catch(e) {
                                console.log("No top screen communication script available");
                            }
                        }
                    } else {
                        // Browser prejde na zmenu jazyka
                        main.languageLabels(lang, JSON.stringify(staticTexts));
                    }

                } else {
                    main.lockApp(-1, "NO TEXTS !");
                }

            })
            .fail(function (jqXHR) {
                jqXHR.requestUrl = requestUrl;
                main.lockApp(-1, "TEXTS ERROR !");
            });
    },

    // Funkcia prijima preklady pre dopytovany jazyk SetPlayerLanguage() -> main.languageLabels()
    languageLabels: function(lang, staticTexts, initiator) {
        try {
            if (staticTexts = JSON.parse(staticTexts)) {
                // Ulozi preklady
                main.createLog(3, "LanguageLabelsChange_Success", "TEXTS LOADED " + lang + " " + initiator);
                texts = staticTexts;
                offer.lang = lang;
                // nastavenie jazyka pre nacitanie/zobrazenie bonusov po starte a po zmene jazyka ak je iny ako "sk" alebo "en"
                offer.bonusesLang = ["sk","en"].includes(lang) ? lang : "en"; 
                // Nastevenie zobrazenia sekcii "Herny plan" a DOXXbet klub
                more.menu.setProperties(profile.Terms, profile.GDPR, profile.Bonuses, profile.Club, profile.ClubHomeButton, profile.ClubNew, profile.ClubCompetition);
                // Zmena jazyka na tiketovej sluzbe
                ticket.ticketLang();
                // Nanovo vytvori elementy pre detail tiketu
                $("#ticketStatus #section").empty().append(ticketStatusSection).trigger("create");
                // Nastavy zvoleny jazyk
                main.setLabels(lang);
                if (stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID &&
                    player.incomeSourcesModule.possibleIncomeSourcesLang !== lang) {
                    player.incomeSourcesModule.getPossibleIncomeSources()
                        .then(function (possibleIncomeSources) {
                            if (possibleIncomeSources) {
                                return player.incomeSourcesModule.incomeSourcesToUserSettings();
                            }
                        })
                        .catch(function (error) {
                            main.createLog(2, "LanguageLabelsIncomeSourcesRefresh_Failed", "error: " + error);
                        });
                }
                // Vymaze ticketStatus a nanovo vytvori direktivu
                delete T.ticketStatus;
                directives.ticketDetailDirective.ticketStatus();
                // Nacitanie bonusov v aktualnom jazyku a po zmene jazyka
                more.menu.getBonusList(profile.TileInfo, false);
                // Zmena jazyka na vrchnej obrazovke
                communication.topScreen('setLanguage', lang);
                // Nastavi gameparty
                shared.getGameParts();
                // Nanovo vyrenderuje moje tikety, bez dopytovania novych dat
                player.playerTickets.myTicketsFilter(false, false);
                // Prejde na domovsku obrazovku vykresli popularne ligy a nastavi ribbony na domovskej v dlazdiciach
                if (cache) {
                    // Nastavi home obrazovku - popularne ligy
                    if (cache.EventsOfDay) {
                        delete cache.EventsOfDay;
                    }
                    if (cache.TopOfferLeagueCups) {
                        delete cache.TopOfferLeagueCups;
                    }
                }
                main.setPage(1);
                if ((profile.Club || profile.Bonuses) && profile.ClubHomeButton) {
                    if (profile.ClubNew || profile.ClubCompetition) {
                        $("#homeButtons .ui-block-b .home-new").removeClass().addClass("home-new new-" + offer.lang);
                    } else if (profile.LocalCompetition) {
                        $("#homeButtons .ui-block-b .home-new").removeClass().addClass("home-new new-" + offer.lang + " competition-" + profile.LocalCompetition.toLowerCase());
                    }
                }
                // Konkretne akcie pre roznych initiatorov
                switch (initiator) {
                    case "setBalanceWithPlayerInfo":
                        if (profile.IsLoginRequired) {
                            if (restriction = ticket.playerNotAllowedForBetting()) {
                                if (restriction === "PLAYER_NOT_VERIFIED") {
                                    // Prihlaseny a zaroven neovereny player nema moznost betovat
                                    modal.openVLCModal(restriction);
                                } else if (restriction === "PLAYER_INTERNAL_RVO_ERROR") {
                                    // Nastala chyba pri volani RVO sluzby
                                    modal.showErrObj(2, 5, {err1: texts.InternalRvoError, errType: "InternalRvoError"});
                                }
                            }
                        }
                        break;
                    case "setBalanceWithPlayerInfo":
                    case "clearUserSettings":
                    case "closeUserSettingsModal":
                    default:
                        // main.setPage(1);
                        break;
                }
            }
        } catch (e) {
            main.createLog(2, "LanguageLabelsChange_Failed_Err", "ERROR in: main.languageLabels() # " + e);
            return false;
        }
    },

    // Nacitanie pridavnych kniznic
    loadAdditionalScripts: function() {
        if (profile.ShowStatistics && profile.StatisticsParameter == "hasBetradarHostedStatistics") {
            $("head").append('<script type="text/javascript" src="scripts/sportradar-iframescript.min.js"></script>');
        }
        if (profile.LotteryAllowed) {
            $("head").append('<script type="text/javascript" src="settings/sportbox-lottery.js"></script>');
        }
    },

    // Re-Inicializacna funkcia voci nativeApp (#1)
    initWebAppCheck: function() {
        try {

            if (stored.SBID && stored.CID) {
                return true;

            } else {

                // Ak nema SBID alebo CID tak spusti Re-Inicializaciu s nativnou App (5 pokusov)
                try {
                    main.createLog(3, "InitWebApp_Start", "#" + ct.initWebApp);

                    // Volanie na nativeApp s ocakavanou odpovedou -> setInitializeWebApp() (#2)
                    InitializeWebApp();
                    stored.initWebAppSuccess = true;

                } catch (e) {
                    stored.initWebAppSuccess = false;
                }

                if (stored.initWebAppSuccess && stored.SBID && stored.CID) {
                    // Ak presla inicializacia uspesne tak skontroluje SBID a CID
                    ct.initWebApp = false;
                    return true;

                } else if (!stored.initWebAppSuccess) {
                    // Ak inicializacia nepresla tak sa pokusi o re-inicializaciu (5 pokus pri starte, 1 pokus pri tikete)
                    if (ct.initWebApp && ct.initWebApp < 5) {
                        // Ak sa jedna o firstInit
                        ct.initWebApp++;
                        main.initWebAppCheck();

                    } else {
                        // Ak sa re-inicializacia nepodarila
                        ct.initWebApp = false;
                        main.initWebAppFailed();
                        return false;
                    }
                }
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.initWebAppFailed();
            return false;
        }
    },

    // Inicializacia nativeAPP zlyhala
    initWebAppFailed: function() {
        main.lockApp(-1, "APP SYNC ERROR !");
        if (ct.initWebApp) {
            main.createLog(2, "REFACTOR FAIL 3");
        } else {
            main.createLog(2, "REFACTOR FAIL 4");
        }
        // Zamknutie obrazovky s oneskorenim 5 sekund
        setTimeout(function () {
            main.createLog(1, "StartInitFailed", "LOCK SB # URL: " + url.base);
            setTimeout(function () {
                main.stopHeartBeat();
            }, sets.refreshTime);
        }, sets.heartBeat);
    },

    // Nativna App spusta overenie inicializacie (#2)
    setInitializeWebApp: function(data) {
        try {
            var dataLog = data;
            if (dataLog && dataLog.UserTranslations) delete dataLog.UserTranslations;
            main.createLog(3, "InitWebApp_Done", "#" + ct.initWebApp + " # DATA: " + dataLog);

            if (data) {
                // Rozparsovanie na JSON
                try {
                    data = $.parseJSON(data);
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    // Neodchytena vynimka, reload page / reinicializacia
                    main.lockApp(-1, "INIT DATA ERROR !");
                    setTimeout(function () {
                        main.createLog(2, "InitWebApp_Error", "JSON PARSE ERROR # " + e);
                        window.location = url.base;
                    }, 5000);
                    return false;
                }

                // Nastavenie SportBox ID
                if (data.SbId = parseInt(data.SbId)) stored.SBID = data.SbId;

                // Nastavenie Client ID
                if (data.ClientId = parseInt(data.ClientId)) stored.CID = data.ClientId;

                // Nastavenie verzie nativnej aplikacie (pre GA4)
                if (data.NativeAppVersion) stored.NativeAppVersion = data.NativeAppVersion;

                if (stored.SBID && stored.CID) {

                    // Ak ma SBID aj CID tak spusti heartBeat voci nativeApp (#3a)
                    if (!stored.browser) main.startApp(2);
                }

                // Ulozi preklady
                if (data.UserTranslations) {
                    main.createLog(3, "InitWebApp_Success", "TEXTS LOADED");
                    texts = data.UserTranslations;
                }

                // Nastavi rozlisenie obrazovky
                if (data.Resolution) {
                    $("body").addClass("resolution-" + data.Resolution);
                    profile.Resolution = data.Resolution;
                }

                // Nastavi krajinu pre ktoru sa ma zobrazit kurzova ponuka
                if (data.Country) offer.country = data.Country.toUpperCase();

                // Nastavi hladinu
                if (data.Level) offer.level = data.Level;

                // Nastavi zonu pre cas na kurzovej ponuke
                if (data.TimeZone = parseInt(data.TimeZone)) offer.zone = data.TimeZone;

                // Nastavi jazyk UI
                if (data.LanguageId) offer.lang = data.LanguageId;
                
                // Nastavi jazyk Bonusov
                if (offer.lang) offer.bonusesLang = ["sk","en"].includes(offer.lang) ? offer.lang : "en";

                // Nastavi default jazyk (per sportbox)
                if (data.LanguageIdDefault) profile.LanguageIdDefault = data.LanguageIdDefault;

                // Nastavenie meny
                if (data.CurrencyId) profile.Currency = data.CurrencyId;

                // Nastavenie ci maju byt winy zapnute
                if (typeof data.IsWinCurrency !== 'undefined') profile.IsWinCurrency = data.IsWinCurrency;

                // Nastavenie koeficientu pre prepocet meny na winy
                if (data.WinCurrencyConversionRate) profile.WinCurrencyConversionRate = data.WinCurrencyConversionRate;

                // Nastavenie symbolu pre winy
                if (data.WinCurrencySymbol) profile.WinCurrencySymbol = data.WinCurrencySymbol;

                // Nastavenie locales (formatovanie meny - oddelovac tisicov)
                if (data.LocaleString) profile.LocaleString = data.LocaleString;

                // Nastavenie verzie klienta
                if (data.Version) profile.Version = data.Version;

                // Nastavenie Feedu
                if (data.CountryFeed) profile.CountryFeed = data.CountryFeed;

                // Prepinanie feedu povodny/'oddscache'
                if (typeof data.OddsCacheFeed !== 'undefined') profile.OddsCacheFeed = data.OddsCacheFeed;

                // Nastavenie specifickej domeny v pripade feedu 'oddscache'
                if (data.OddsCacheFeedCountryFeed) profile.OddsCacheFeedCountryFeed = data.OddsCacheFeedCountryFeed;

                // Nastavenie customerID pre feed 'oddscache'
                if (data.OfferOddsCacheCustomerID) profile.OfferOddsCacheCustomerID = data.OfferOddsCacheCustomerID;

                // Nastavi sa Zobrazenie Bonusov
                if (data.BonusList) profile.BonusList = data.BonusList;

                // Nastavi konkretne bonusy - marketingove podstranky
                if (data.TileInfo) profile.TileInfo = data.TileInfo;

                // Mozne prepnutie na FLAT CSS design
                if (typeof data.FlatCSS !== 'undefined') profile.FlatCSS = data.FlatCSS;

                // Nastavenie ci sa jedna o sportbox Victory tip
                if (typeof data.VictoryMachine !== 'undefined') profile.VictoryMachine = data.VictoryMachine;

                // Nastavenie zobrazenia tlacidla Tlacit tiket v detaile tiketu
                if (typeof data.TicketStatusPrintTicket !== 'undefined') profile.TicketStatusPrintTicket = data.TicketStatusPrintTicket;

                // Nastavenie zobrazenia tlacidla Vratit hotovost (Tlac kreditneho listka)
                if (typeof data.TicketStatusPrintCredit !== 'undefined') profile.TicketStatusPrintCredit = data.TicketStatusPrintCredit;

                // Nastavenie zobrazenia tlacidla Prevod na online (Prevedie vyhru na online sparovany ucet)
                if (typeof data.TicketStatusPayableToOnline !== 'undefined') profile.TicketStatusPayableToOnline = data.TicketStatusPayableToOnline;

                // Nastavenie zobrazenia tlacidla Editacie tiketu (zapnutie/vypnutie)
                if (typeof data.EditTicket !== 'undefined') profile.EditTicket = data.EditTicket;

                // Nastavenie default poradia oddov v detaile tiketu
                if (typeof data.TicketStatusOrderDefault !== 'undefined') profile.TicketStatusOrderDefault = data.TicketStatusOrderDefault;

                // Nastavenie velkosti loadera pri tikete na schalenie
                if (typeof data.LargeTicketApproveLoader !== 'undefined') profile.LargeTicketApproveLoader = data.LargeTicketApproveLoader;

                // Nastavenie ktore hrac moze menit v player nastaveniach
                if (typeof data.UserSettingsSections !== 'undefined') profile.UserSettingsSections = data.UserSettingsSections;

                // Nastavenie zapnutie/vypnutie oblubenych v ponuke
                if (typeof data.Favorite !== 'undefined') profile.Favorite = data.Favorite;

                // Nastavenie default povolenej zmeny kurzu pri staveni tiketu
                if (typeof data.AllowedRateChangeDefault !== 'undefined') profile.AllowedRateChangeDefault = data.AllowedRateChangeDefault;

                // Nastavenie zapnutie/vypnutie warning hlasky na home obrazovke nad dlazdicami (napr. info o odstavke)
                if (typeof data.HomeWarning !== 'undefined') profile.HomeWarning = data.HomeWarning;

                // Stranka ktora sa spusti pri starte SB (1 - 8)
                if (typeof data.startPage !== 'undefined') profile.startPage = data.startPage;

                // Stranka na ktorej sa overuje konektivita pri jej vypadku
                if (typeof data.checkPage !== 'undefined') profile.checkPage = data.checkPage;

                // Nastavenie zobrazenia informacnej hlasky o aktualnosti kurzov v plachte pre rozne "page"
                if (typeof data.pageActualisationInfo !== 'undefined') profile.pageActualisationInfo = data.pageActualisationInfo;

                // Nastavenie zobrazenia informacnej hlasky o aktualnosti kurzov v plachte pre rozne "page"
                if (typeof data.MinCombinationMinRate !== 'undefined') profile.MinCombinationMinRate = data.MinCombinationMinRate;

                // Nastavenie casu kedy sa maju media vypnut na vrchnej obrazovke, sluzi ako poistka vypinania (MT, QB, VG) na screenApp
                if (typeof data.MediaDisableProtectionTime !== 'undefined') profile.MediaDisableProtectionTime = data.MediaDisableProtectionTime;

                // STATIC CDN URL Graphic Repo per farma: https://repository.codium.sk/doxxbet/static-doxxbet-sk/graphic-sportbox-doxxbet-sk
                if (typeof data.GraphicSportboxURL !== 'undefined') profile.GraphicSportboxURL = data.GraphicSportboxURL;

                // Nastavenie ID sportov pri ktorych sa ma ignorovat watcher (automaticke vratenie na landing) - caka sa na signalR gamepart pre ukoncenie zapasu
                if (typeof data.WatcherIgnoredSportsID !== 'undefined') profile.WatcherIgnoredSportsID = data.WatcherIgnoredSportsID;

                // Nastavenie ci sa ma zobrazovat informacia o zdroji prijmu - plati len pre prihlaseneho hraca
                if (typeof data.IsSourceOfIncome !== 'undefined') profile.IsSourceOfIncome = data.IsSourceOfIncome;

                // Nastavenie hranice pri ktorej sa ma zobrazit okno vyberu zdrojov prijmu - pre prihlaseneho hraca
                if (typeof data.SourcesOfIncomeOverallTotalBetLimit !== 'undefined') profile.SourcesOfIncomeOverallTotalBetLimit = data.SourcesOfIncomeOverallTotalBetLimit;

                // Nastavenie ci je nutne aby bol hrac prihlaseny pre stavenie tiketu
                if (typeof data.IsLoginRequired !== 'undefined') profile.IsLoginRequired = data.IsLoginRequired;

                // Nastavenie ci je prihlasenie pomocou biometrie jediny sposob prihlasovania
                if (typeof data.IsBiometricLoginOnly !== 'undefined') profile.IsBiometricLoginOnly = data.IsBiometricLoginOnly;

                // Nastavenie ci sa jedna o SB v herni (v pripade ze je IsLoginRequired nastaveny na true, tak je potrebne priglasovanie v herni)
                if (typeof data.IsGamingClub !== 'undefined') profile.IsGamingClub = data.IsGamingClub;

                // Nastavenie PlayerID manualne overeneho hraca (neprihlasuje sa na tiketovu sluzbu), funguje v 'starom rezime' anonymneho tipovania (volanie placebetsb)
                if (typeof data.ManualVerifiedPlayerID !== 'undefined') profile.ManualVerifiedPlayerID = data.ManualVerifiedPlayerID;

                // Nastavenie ci je mozne manualne verifikovat hraca (zobrazenie tlacitka s popisom vo VLC modalnom okne)
                if (typeof data.IsRvoManualUnblockingAllowed !== 'undefined') profile.IsRvoManualUnblockingAllowed = data.IsRvoManualUnblockingAllowed;

                // Nastavenie ci je nutna casova aktivacia karty
                if (typeof data.VerifyCardActivation !== 'undefined') profile.VerifyCardActivation = data.VerifyCardActivation;

                // Mozne prepnutie na FLAT CSS design
                if (typeof data.IsRetail !== 'undefined') profile.IsRetail = data.IsRetail;

                // Sprava LIVE ponuky a VirtualGames
                if (typeof data.Live !== 'undefined') offer.live = data.Live;

                // Nastavi zobrazenie VirtualGames
                if (typeof data.VirtualGames !== 'undefined') profile.VirtualGames = data.VirtualGames;

                // Nastavi zvyraznenie NewVirtualGameIDs
                if (typeof data.NewVirtualGameIDs !== 'undefined') profile.NewVirtualGameIDs = data.NewVirtualGameIDs;

                // Nastavi providerov pre ligy vo virtualnych sportoch
                if (typeof data.VirtualsProviders !== 'undefined') profile.VirtualsProviders = data.VirtualsProviders;

                // Nastavi ligy virtualnych hier ktore nemaju byt zobrazene
                if (typeof data.VirtualGameLeaguesDisabled !== 'undefined') profile.VirtualGameLeaguesDisabled = data.VirtualGameLeaguesDisabled;

                // Nastavi zobrazenie ovladania hlasitosti
                if (typeof data.HaveSound !== 'undefined') profile.HaveSound = data.HaveSound; // ! zatial sa natvrdo posiela false z nativky !

                // Maximálna hlasitosť na sportboxe
                if (typeof data.MaxVolume !== 'undefined') profile.MaxVolume = data.MaxVolume;

                // Moznost vysledkov v spodnom menu
                if (typeof data.Results !== 'undefined') profile.Results = data.Results;

                // Nastavenie zobrazenia nazvov tipov
                if (typeof data.TipsFormat !== 'undefined')
                    switch (data.TipsFormat) {
                        case 'true':
                            profile.TipsFormat = true;
                            break;
                        case 'false':
                            profile.TipsFormat = false;
                            break;
                        default:
                            profile.TipsFormat = data.TipsFormat;
                            break;
                    }

                // Nastavi moznost pouzitia freebetov na SB
                if (typeof data.Freebet !== 'undefined') profile.Freebet = data.Freebet;

                // Nastavi moznost pouzitia bonifikacii na SB
                if (typeof data.Bonification !== 'undefined') profile.Bonification = data.Bonification;

                // Nastavi moznost odkupu tiketu na SB
                if (typeof data.RedeemTicket !== 'undefined') {
                    profile.RedeemTicket = data.RedeemTicket;
                    if (typeof data.RedeemTicketAuto !== 'undefined') profile.Redeem.TicketAuto = data.RedeemTicketAuto;
                    if (typeof data.RedeemCheckPlayer !== 'undefined') profile.Redeem.CheckPlayer = data.RedeemCheckPlayer;
                    if (typeof data.RedeemCheckPlayerVerified !== 'undefined') profile.Redeem.CheckPlayerVerified = data.RedeemCheckPlayerVerified;
                }

                // Nastavi moznost Booster bonusu na SB a aktualny nazov pre bonus (per farma koli prekladom)
                if (typeof data.BoosterBonus !== 'undefined') profile.BoosterBonus = data.BoosterBonus;
                if (typeof data.BoosterBonusName !== 'undefined') profile.BoosterBonusName = data.BoosterBonusName;

                // Nastavi zobrazenie povinnych info vo Footri
                if (typeof data.ShowObligatoryInfo !== 'undefined') profile.ShowObligatoryInfo = data.ShowObligatoryInfo;

                // Nastavi sa Herny Plan pre danu krajinu, ak je prazdny tak sa herny plan nezobrazi
                if (typeof data.Terms !== 'undefined') profile.Terms = data.Terms;
                if (typeof data.TermsAdditional !== 'undefined') profile.TermsAdditional = data.TermsAdditional;

                // Nastavi sa Zobrazenie GDPR
                if (typeof data.GDPR !== 'undefined') profile.GDPR = data.GDPR;

                // Nastavi sa Zobrazenie Bonusov (marketingove podstranky spolu s dlazdicou ktora na ne smeruje)
                if (typeof data.Bonuses !== 'undefined') profile.Bonuses = data.Bonuses;

                // Nastavi predvolenu marketingovu podstranku
                if (typeof data.BonusOpenDefault !== 'undefined') profile.BonusOpenDefault = data.BonusOpenDefault;

                // Nastavi DOXXbet klub pre danu krajinu, ak je prazdny tak sa herny klub nezobrazi
                if (typeof data.Club !== 'undefined')
                    if (profile.Club = data.Club) {
                        // Nastavi homeButton dlazdicu s preklikom na klub
                        if (typeof data.ClubHomeButton !== 'undefined') profile.ClubHomeButton = data.ClubHomeButton;
                        // Oznaci na homeScreene novinku
                        if (typeof data.ClubNew !== 'undefined') profile.ClubNew = data.ClubNew;
                        // Zobrazenie napisu Vernostna karta v dlazdici na home obrazovke
                        if (typeof data.ClubHomeButtonLabel !== 'undefined') profile.ClubHomeButtonLabel = data.ClubHomeButtonLabel;
                        // Sutaz - zobrazenie na homeScreene namiesto
                        if (typeof data.ClubCompetition !== 'undefined') profile.ClubCompetition = data.ClubCompetition;
                        // ID aktualnej sutaze
                        if (typeof data.ClubCompetitionIDs !== 'undefined') profile.ClubCompetitionIDs = data.ClubCompetitionIDs;
                        // Automaticky otvori sekciu Sutaz v DOXXbete klub podla daneho ID
                        if (typeof data.ClubPageCompetition !== 'undefined') profile.ClubPageCompetition = data.ClubPageCompetition;
                        // Automaticky otvori sekciu podla daneho ID
                        if (typeof data.ClubPageAutoOpen !== 'undefined') profile.ClubPageAutoOpen = data.ClubPageAutoOpen;
                        // Klubova karta - zobrazenie pomocnika s klubovou kartou, zobrazenie polozky zadania cisla karty v menu
                        if (typeof data.ClubLoyaltyCard !== 'undefined') profile.ClubLoyaltyCard = data.ClubLoyaltyCard;
                        // URL pre registraciu Virtual Loyalty Card
                        if (typeof data.ClubVLCURL !== 'undefined') profile.ClubVLCURL = data.ClubVLCURL;
                        // Skryje dlazdicu registracneho bonusu a sekciu v doxxbete
                        if (typeof data.ClubDisplayVLC !== 'undefined') profile.ClubDisplayVLC = data.ClubDisplayVLC;
                        // URLka html stranky s obrazkom ktora sa ma zobrazit v DOXXbet klub => BETKLUB
                        if (typeof data.ClubBetClubURL !== 'undefined') profile.ClubBetClubURL = data.ClubBetClubURL;
                        // Automaticky skryje dane sekcie
                        if (data.ClubPagesHide && data.ClubPagesHide.length) profile.ClubPagesHide = data.ClubPagesHide;
                    }

                // Nastavi moznosti biometrie
                if (typeof data.BiometryLogin !== 'undefined') {
                    // Moznost prihlasenia pomocou biometrie
                    profile.BiometryLogin = data.BiometryLogin;
                    // Nastavenie zobrazovanej grafiky pre biometriu
                    if (typeof data.BiometryAppearanceVersion !== 'undefined') profile.Biometry.AppearanceVersion = data.BiometryAppearanceVersion;
                    // Nastavenie biometrie pre prednu/zadnu kameru
                    if (typeof data.BiometryFrontCamera !== 'undefined') profile.Biometry.FrontCamera = data.BiometryFrontCamera;
                    // Nastavenie poctu za sebou iducich automatickych snimkov pri detekcii tvare (posiela sa na nativeApp sekvencne)
                    if (typeof data.BiometryBatchCount !== 'undefined') profile.Biometry.BatchCount = data.BiometryBatchCount;
                    // Nastavenie max dlzky casu pocas ktoreho ma kamera rozpoznavat tvar do prveho rozpoznania
                    if (typeof data.BiometryMaxFaceDetectionTime !== 'undefined') profile.Biometry.MaxFaceDetectionTime = data.BiometryMaxFaceDetectionTime;
                    // Nastavenie casu zobrazovanie informacnej hlasky o neuspesnom prihlaseni po neuspesnom rozpoznani tvare s doplnujucou informaciou (pouziva screenApp)
                    if (typeof data.FailedPhotoDisplayTime !== 'undefined') profile.FailedPhotoDisplayTime = data.FailedPhotoDisplayTime;
                    // Nastavenie casu zobrazovania informacnej hlasky o uspechu/neuspechu prihlasenia pomocou tvare - bez doplnujucej informacie (pouziva screenApp)
                    if (typeof data.LoginMessageDisplayTime !== 'undefined') profile.Biometry.LoginMessageDisplayTime = data.LoginMessageDisplayTime;
                    // Nastavenie dlzky casu pocas ktoreho sa ma zobrazovat PIN v uzivatelskych nastaveniach (po overeni tvare voci playerID)
                    if (typeof data.BiometryTimeoutPin !== 'undefined') profile.Biometry.BiometryTimeoutPin = data.BiometryTimeoutPin;
                    // Konfigurovatelne parametre podla dokumentacie innovatrics:
                    // https://developers.innovatrics.com/digital-onboarding/technical/remote/dot-web-face/latest/documentation/#_supported_browsers
                    if (typeof data.BiometryFaceConfidence !== 'undefined') profile.Biometry.FaceConfidence = data.BiometryFaceConfidence;
                    if (typeof data.BiometrySharpnessThreshold !== 'undefined') profile.Biometry.SharpnessThreshold = data.BiometrySharpnessThreshold;
                    if (typeof data.BiometryBrightnessLowThreshold !== 'undefined') profile.Biometry.BrightnessLowThreshold = data.BiometryBrightnessLowThreshold;
                    if (typeof data.BiometryBrightnessHighThreshold !== 'undefined') profile.Biometry.BrightnessHighThreshold = data.BiometryBrightnessHighThreshold;
                    if (typeof data.BiometryOutOfBoundsThreshold !== 'hideInfoModal') profile.Biometry.OutOfBoundsThreshold = data.BiometryOutOfBoundsThreshold;
                    if (typeof data.BiometryMinFaceSizeRatio !== 'undefined') profile.Biometry.MinFaceSizeRatio = data.BiometryMinFaceSizeRatio;
                    if (typeof data.BiometryMaxFaceSizeRatio !== 'undefined') profile.Biometry.MaxFaceSizeRatio = data.BiometryMaxFaceSizeRatio;
                    if (typeof data.BiometryDevicePitchAngleThreshold !== 'undefined') profile.Biometry.DevicePitchAngleThreshold = data.BiometryDevicePitchAngleThreshold;
                    if (typeof data.BiometryCandidateSelectionDuration !== 'undefined') profile.Biometry.CandidateSelectionDuration = data.BiometryCandidateSelectionDuration;
                }

                // Biometry Onboarding
                if (typeof data.BiometryOnboarding !== 'undefined') profile.BiometryOnboarding = data.BiometryOnboarding;
                // Konfigurovatelne parametre podla dokumentacie innovatrics:
                // https://developers.innovatrics.com/digital-onboarding/technical/remote/dot-web-document/latest/documentation/
                if (typeof data.BiometryOnboardingDocumentSharpnessThreshold !== 'undefined') profile.Biometry.BiometryOnboardingDocumentSharpnessThreshold = data.BiometryOnboardingDocumentSharpnessThreshold;
                if (typeof data.BiometryOnboardingSelfieSharpnessThreshold !== 'undefined') profile.Biometry.BiometryOnboardingSelfieSharpnessThreshold = data.BiometryOnboardingSelfieSharpnessThreshold;
                if (typeof data.BiometryOnboardingSelfieCandidateSelectionDuration !== 'undefined') profile.Biometry.BiometryOnboardingSelfieCandidateSelectionDuration = data.BiometryOnboardingSelfieCandidateSelectionDuration;
                if (typeof data.BiometryOnboardingDocumentCandidateSelectionDuration !== 'undefined') profile.Biometry.BiometryOnboardingDocumentCandidateSelectionDuration = data.BiometryOnboardingDocumentCandidateSelectionDuration;

                // Nastavi moznosti QuickBetov
                if (typeof data.QuickBetsAllowed !== 'undefined') {
                    // Povolenie zobrazenia quickbetov
                    profile.QuickBetsAllowed = data.QuickBetsAllowed;
                    // Zobrazenie quickbetov na home obrazovke
                    if (typeof data.QuickBetsHomePage !== 'undefined') profile.QuickBets.HomePage = data.QuickBetsHomePage;
                    // Zobrazenie quickbetov v LIVE
                    if (typeof data.QuickBetsLive !== 'undefined') profile.QuickBets.Live = data.QuickBetsLive;
                    // Zobrazenie quickbetu ako novinky
                    if (typeof data.QuickBetsIsNew !== 'undefined') profile.QuickBets.IsNew = data.QuickBetsIsNew;
                    // Nastavenie ci sa maju quickbety zobrazovat v jedinom iframe na spodnej obrazovke, alebo sa maju akcne tlacitka zobrazovat na spodnej a video na vrchnej obrazovke
                    if (typeof data.QuickBetsVideoOnTop !== 'undefined') profile.QuickBets.VideoOnTop = data.QuickBetsVideoOnTop;
                    // Nastavenie id sportu pre quickbety
                    if (typeof data.QuickBetsSportID !== 'undefined') profile.QuickBets.SportID = data.QuickBetsSportID;
                    // Nastavenie prekladu pre quickbet sport
                    if (typeof data.QuickBetsSportName !== 'undefined') profile.QuickBets.SportName = data.QuickBetsSportName;
                    // Nastavenie obrazka pozadia pre quickbety
                    if (typeof data.QuickBetsImg !== 'undefined') profile.QuickBets.Img = data.QuickBetsImg;
                    // Nastavenie url pri quickbete
                    if (typeof data.QuickBetsUrlControls !== 'undefined') profile.QuickBets.UrlControls = data.QuickBetsUrlControls;
                    // Nastavenie video quickbet url
                    if (typeof data.QuickBetsUrlVideo !== 'undefined') profile.QuickBets.UrlVideo = data.QuickBetsUrlVideo;
                    // Nastavenie QuickBet Prepínač - výhry pripisovať k zostatku
                    if (typeof data.QuickBetsBalanceAutoAdd !== 'undefined') profile.QuickBets.BalanceAutoAdd = data.QuickBetsBalanceAutoAdd;
                }

                // Nastavi moznosti Lottery
                if (typeof data.LotteryAllowed !== 'undefined') {
                    // Povolenie zobrazenia loteriovych hier
                    profile.LotteryAllowed = data.LotteryAllowed;
                    // Nastavenie id regionu loteriovych hier
                    if (typeof data.LotteryRegionID !== 'undefined') profile.Lottery.RegionID = data.LotteryRegionID;
                    // Nastavenie povolenych providerov pre loteriove hry
                    if (typeof data.LotteryProviders !== 'undefined') profile.Lottery.Providers = data.LotteryProviders;
                    // Nastavenie vkladov v kalkulacke pre loteriove hry
                    if (typeof data.LotteryShortcutBets !== 'undefined') profile.Lottery.ShortcutBets = data.LotteryShortcutBets;
                }

                // Nastavi defaultnu hodnotu FeeRate (hodnota sa len uklada do profilu, realna sa berie z ticketWS)
                if (typeof data.Fee !== 'undefined') profile.Fee = data.Fee;

                // Nastavi sa zobrazenie manipulacneho poplatku v tikete
                if (typeof data.DisplayFee !== 'undefined') profile.DisplayFee = data.DisplayFee;

                // Nastavi sa zobrazenie textu v detaile tiketu ci bol tiket podany na inej prevadzke
                if (typeof data.OtherLocationShow !== 'undefined') profile.OtherLocationShow = data.OtherLocationShow;

                // Nastavi sa moznost klientskeho storna tiketov
                if (typeof data.ClientStorno !== 'undefined') profile.ClientStorno = data.ClientStorno;

                // Nastavi zobrazenie MatchTracker, je mozne ho zablokovat
                if (typeof data.MatchTracker !== 'undefined') profile.MatchTracker = data.MatchTracker;

                // Nastavi zobrazenie Stream, je mozne ho zablokovat
                if (typeof data.IsStreamEnabled !== 'undefined') profile.IsStreamEnabled = data.IsStreamEnabled;

                // Nastavi povolenych providerov pre Stream
                if (typeof data.StreamProviders !== 'undefined') profile.StreamProviders = data.StreamProviders;

                // Nastavi zorbazenie BetBuilder Agg
                if (typeof data.BetBuilderAgg !== 'undefined') profile.BetBuilderAgg = data.BetBuilderAgg;

                // Nastavi zorbazenie BetBuilder Agg pre LIVE
                if (typeof data.BetBuilderAggLive !== 'undefined') profile.BetBuilderAggLive = data.BetBuilderAggLive;

                // Nastavi parameter obmedzenia dat
                if (typeof data.IsConnectionFupEnabled !== 'undefined') profile.IsConnectionFupEnabled = data.IsConnectionFupEnabled;

                // Nastavi zobrazenie GoldenLeague, je mozne ho zablokovat
                if (typeof data.GoldenLeagueBlocked !== 'undefined') profile.GoldenLeagueBlocked = data.GoldenLeagueBlocked;

                // Nastavi zobrazenie Jackpotov, je mozne ho zablokovat
                if (typeof data.JackpotsBlocked !== 'undefined') profile.JackpotsBlocked = data.JackpotsBlocked;

                // Nastavi podporovane typy Jackpotov
                if (data.JackpotBetTypes) profile.JackpotBetTypes = data.JackpotBetTypes;

                // Nastavi nazov lokalnej sutaze
                if (data.LocalCompetition) profile.LocalCompetition = data.LocalCompetition;

                // Nastavi zobrazenie rozsirenej ponuky, je mozne ho zablokovat
                if (typeof data.ExtendedOffer !== 'undefined') profile.ExtendedOffer = data.ExtendedOffer;

                // Nastavi zobrazovanie statistik, je mozne ho zablokovat
                if (typeof data.ShowStatistics !== 'undefined') profile.ShowStatistics = data.ShowStatistics;

                // Nastavi parameter pre zobrazovanie statistik ("hasStatistics", "hasBetradarHostedStatistics")
                if (data.StatisticsParameter) profile.StatisticsParameter = data.StatisticsParameter;

                // Nastavenie minimalneho mozneho depozitu
                if (data.MinDep = parseFloat(data.MinDep)) profile.MinDep = data.MinDep;

                // Nastavenie minimalneho mozneho depozitu pre virtualne hry
                if (data.MinDepVG = parseFloat(data.MinDepVG)) profile.MinDepVG = data.MinDepVG;

                // Nastavenie minimalneho mozneho depozitu na rozpisovy tiket
                if (data.MinDepPerSlip = parseFloat(data.MinDepPerSlip)) profile.MinDepPerSlip = data.MinDepPerSlip;

                // Nastavenie minimalneho poctu kombinacii na rozpisovy tiket
                if (data.MinSlips = parseFloat(data.MinSlips)) profile.MinSlips = data.MinSlips;

                // Nastavenie maximalnej moznej cistej vyhry
                if (data.MaxWin = parseFloat(data.MaxWin)) profile.MaxWin = data.MaxWin;

                // Nastavi pre ake regiony je dostupna tymova analyza
                if (data.TeamAnalysisRegions && data.TeamAnalysisRegions.length) profile.TeamAnalysisRegions = data.TeamAnalysisRegions;

                // Nastavenie detailu zapasu, priamo v liste zapasov
                if (data.InlineDetailLeagueCups) profile.InlineDetailLeagueCups = data.InlineDetailLeagueCups;

                // Skupiny tiketov ktore maju byt dopytovatelne v mojich tiketoch ked je uzivatel prihlaseny
                if (data.MyTickets) profile.MyTickets = data.MyTickets;

                // Statusy podanych tiketov pri ktorych sa ma zobrazit moznost - tlacidlo pre vykreslenie grafu vyobrazujuci stavy s poctami tipov na tikete
                if (data.CountGraphStates) profile.CountGraphStates = data.CountGraphStates;

                // Pocet dni pred exspiraciou kedy sa ma zobrazit text v mojich tiketoch o tom ze tiket coskoro exspiruje
                if (data.NoticeBeforeExpiration) profile.NoticeBeforeExpiration = data.NoticeBeforeExpiration;

                // Hodnota Betk-a ktora sa ma zobrazovat na home obrazovke pri zapasoch dna. Stav X a vyhraj ...
                if (data.EventsOfDayBet) profile.EventsOfDayBet = data.EventsOfDayBet;

                // Nastavenie zobrazenia v liste s 8 odd-mi
                if (typeof data.VirtualsOctava !== 'undefined') profile.VirtualsOctava = data.VirtualsOctava;

                // Nastavenie zobrazenia stromovej struktury virtualnej hry (Virtual Game -> Provider -> League) aj v pripade ze dany sport obsahuje len jednu ligu jedneho providera
                if (typeof data.VirtualsStructure !== 'undefined') profile.VirtualsStructure = data.VirtualsStructure;

                // Nastavenie zobrazenia stromovej struktury virtualnej hry (Virtual Game -> League) za kazdych okolnosti, aj ked dany sport obsahuje len jednu ligu
                if (typeof data.VirtualsStructureProviders !== 'undefined') profile.VirtualsStructureProviders = data.VirtualsStructureProviders;

                // [Betbuilder Aggregator API] Nastavenie url
                if (data.BetBuilderAggProxy) profile.BetBuilderAggProxy = data.BetBuilderAggProxy;

                // Nastavenie dostupnych jazykov UI (plati pre vyber jazyka z vrchnej listy, vyber jazyka z user settings)
                if (typeof data.AvailableLanguages !== 'undefined') profile.AvailableLanguages = data.AvailableLanguages;

                // Zapnutie console logu kvoli testovaniu na SB
                if (typeof data.ConsoleLog !== 'undefined') profile.ConsoleLog = data.ConsoleLog;

                // Vypnutie HeartBeatu webApp voci natvieApp kvoli testovaniu na SB
                if (typeof data.StopHeartBeatCheck !== 'undefined') profile.StopHeartBeatCheck = data.StopHeartBeatCheck;

                // Synchronizacia so serverom
                if (ct.initWebApp) {
                    main.createLog(3, "InitWebApp_Success", "SBID: " + stored.SBID + " # CID: " + stored.CID + " # URL: " + url.base);
                } else {
                    main.createLog(3, "InitWebApp_Success", "ALREADY RUNNING - SBID: " + stored.SBID + " # CID: " + stored.CID + " # URL: " + url.base);
                }

                // Prejde na dalsi krok v ramci spustania aplikacie (#3b)
                if (main.initWebAppCheck()) main.startApp(3);

                return true;

            } else {
                // Neuspesna inicializacia
                main.createLog(2, "InitWebApp_Error", "NO DATA");
                main.initWebAppFailed();
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            // Neodchytena vynimka, reload page / reinicializacia
            setTimeout(function () {
                main.createLog(2, "InitWebApp_Error", "ERROR");
                window.location = url.base;
            }, 1000);
            return false;
        }
    },

    // Kontrola funkcnosti aplikacie pre nativeApp
    setHeartBeat: function() {
        clearInterval(rfs.heartBeat);
        rfs.heartBeat = setInterval(function () {
            try {
                HeartBeat();
                return true;
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
        }, sets.heartBeat);
    },

    // Zastavenie heartBeatu pre nativeApp
    stopHeartBeat: function(disableCheck) {
        clearInterval(rfs.heartBeat);
        rfs.heartBeat = null;
        try {
            // Vypne kontrolu HeartBeatu na nativeApp
            if (disableCheck) SetHeartBeatCheck(false);
            return true;
        } catch (e) {
            return false;
        }
    },

    // Kontrola nastavenia offer a profile premennych, prednost maju settings z nativeApp
    checkSettings: function(mainObject, subObjects) {
        try {
            $.each(subObjects, function (i, subObject) {
                try {
                    switch (mainObject) {
                        case 'offer':
                            if (profile.Default.ForceLocalConfig || typeof offer[subObject.toLocaleLowerCase()] === 'undefined')
                                offer[subObject.toLocaleLowerCase()] = profile.Default[subObject];
                            break;
                        case 'profile':
                            if (profile.Default.ForceLocalConfig || typeof profile[subObject] === 'undefined')
                                profile[subObject] = profile.Default[subObject];
                            break;
                        case 'profile-extra':
                            subObject = subObject.split("|");
                            if (profile.Default.ForceLocalConfig || typeof profile[subObject[0]][subObject[1]] === 'undefined')
                                profile[subObject[0]][subObject[1]] = profile.Default[subObject[0] + subObject[1]];
                            break;
                    }
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    // Preskoci chybajucu premennu
                }
            });
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Odchytenie explicitne neodchytenych vynimiek
    catchFunctionCall: function(inputArguments) {
        if (inputArguments && inputArguments.callee) {
            var chainString = inputArguments.callee.name + "(";
            for (i = 0; i < inputArguments.length; i++) {
                chainString += JSON.stringify(inputArguments[i]);
                if (!(i == inputArguments.length - 1)) chainString += ", ";
            }
            return chainString += ")";
        }
    },

    // Nastavenia URL pre ponuku a tiket podla krajiny (#4)
    setConfig: function(country) {
        try {

            // Rucne nastavenie hladiny kurzovej ponuky (defaul / level2)
            if (country) offer.country = country.toUpperCase();

            // Pre nastavenie SB je country klucovy parameter
            if (offer.country) {
                // Potrebne nove vlakno pre spravne nacitanie settings na SB native app
                setTimeout(function () {

                    // Nastavenie premennych podla krajiny
                    $("head").append('<script type="text/javascript" src="' + url.base + 'settings/sportbox-' + offer.country + '.js"></script>');

                    // Kontrola nastavenia premennych - offer
                    main.checkSettings("offer", [
                        "Level",
                        "Zone",
                        "Lang",
                        "Live"
                    ]);

                    // Kontrola nastavenia premennych - profile
                    main.checkSettings("profile", [
                        "LanguageIdDefault",
                        "Currency",
                        "CurrencyCode",
                        "IsWinCurrency",
                        "WinCurrencyConversionRate",
                        "WinCurrencySymbol",
                        "LocaleString",
                        "Version",
                        "GTagID",
                        "CountryFeed",
                        "OddsCacheFeed",
                        "OddsCacheFeedCountryFeed",
                        "OfferOddsCacheCustomerID",
                        "FlatCSS",
                        "IsRetail",
                        "VirtualGames",
                        "NewVirtualGameIDs",
                        "VirtualsProviders",
                        "VirtualGameLeaguesDisabled",
                        "HaveSound",
                        "MaxVolume",
                        "Results",
                        "TipsFormat",
                        "Freebet",
                        "Bonification",
                        "RedeemTicket",
                        "BoosterBonus",
                        "BoosterBonusName",
                        "ShowObligatoryInfo",
                        "Terms",
                        "TermsAdditional",
                        "GDPR",
                        "Bonuses",
                        "BonusList",
                        "TileInfo",
                        "BonusOpenDefault",
                        "Club",
                        "ClubHomeButton",
                        "ClubNew",
                        "ClubHomeButtonLabel",
                        "ClubCompetition",
                        "ClubCompetitionIDs",
                        "ClubPageCompetition",
                        "ClubPageAutoOpen",
                        "ClubLoyaltyCard",
                        "ClubPagesHide",
                        "ClubVLCURL",
                        "ClubDisplayVLC",
                        "ClubBetClubURL",
                        "DisplayFee",
                        "BiometryLogin",
                        "FailedPhotoDisplayTime",
                        "LoginMessageDisplayTime",
                        "BiometryOnboarding",
                        "QuickBetsAllowed",
                        "LotteryAllowed",
                        "OtherLocationShow",
                        "ClientStorno",
                        "MatchTracker",
                        "IsStreamEnabled",
                        "StreamProviders",
                        "StreamAdjustVolume",
                        "GoldenLeagueBlocked",
                        "JackpotsBlocked",
                        "JackpotBetTypes",
                        "LocalCompetition",
                        "ExtendedOffer",
                        "VirtualsOctava",
                        "VirtualsStructure",
                        "VirtualsStructureProviders",
                        "BetBuilderAggProxy",
                        "BetBuilderAgg",
                        "BetBuilderAggLive",
                        "AvailableLanguages",
                        "ShowStatistics",
                        "StatisticsParameter",
                        "IsConnectionFupEnabled",
                        "MinDep",
                        "MinDepVG",
                        "MinDepPerSlip",
                        "MinSlips",
                        "MaxWin",
                        "TeamAnalysisRegions",
                        "InlineDetailLeagueCups",
                        "MyTickets",
                        "CountGraphStates",
                        "NoticeBeforeExpiration",
                        "EventsOfDayBet",
                        "VictoryMachine",
                        "TicketStatusPrintTicket",
                        "TicketStatusPrintCredit",
                        "TicketStatusPayableToOnline",
                        "EditTicket",
                        "TicketStatusOrderDefault",
                        "LargeTicketApproveLoader",
                        "UserSettingsSections",
                        "Favorite",
                        "AllowedRateChangeDefault",
                        "HomeWarning",
                        "startPage",
                        "checkPage",
                        "pageActualisationInfo",
                        "MinCombinationMinRate",
                        "MediaDisableProtectionTime",
                        "GraphicSportboxURL",
                        "WatcherIgnoredSportsID",
                        "IsSourceOfIncome",
                        "SourcesOfIncomeOverallTotalBetLimit",
                        "IsLoginRequired",
                        "IsBiometricLoginOnly",
                        "IsGamingClub",
                        "ManualVerifiedPlayerID",
                        "IsRvoManualUnblockingAllowed",
                        "VerifyCardActivation",
                        "ConsoleLog",
                        "StopHeartBeatCheck"
                    ]);

                    // Pre moznost testovania vypne HeartBeatCheck na nativeApp - SetHeartBeatCheck(false)
                    if (profile.StopHeartBeatCheck) main.stopHeartBeat(true);

                    // Kontrola nastavenia premennych - profile-extra
                    main.checkSettings("profile-extra", [
                        "Redeem|TicketAuto",
                        "Redeem|CheckPlayer",
                        "Redeem|CheckPlayerVerified"
                    ]);

                    // Kontrola nastavenia premennych - profile-extra
                    main.checkSettings("profile-extra", [
                        "Biometry|AppearanceVersion",
                        "Biometry|FrontCamera",
                        "Biometry|BatchCount",
                        "Biometry|MaxFaceDetectionTime",
                        "Biometry|TimeoutPin",
                        "Biometry|FaceConfidence",
                        "Biometry|SharpnessThreshold",
                        "Biometry|BrightnessLowThreshold",
                        "Biometry|BrightnessHighThreshold",
                        "Biometry|OutOfBoundsThreshold",
                        "Biometry|MinFaceSizeRatio",
                        "Biometry|MaxFaceSizeRatio",
                        "Biometry|DevicePitchAngleThreshold",
                        "Biometry|CandidateSelectionDuration"
                    ]);

                    // Kontrola nastavenia premennych - profile-extra
                    main.checkSettings("profile-extra", [
                        "Biometry|OnboardingDocumentSharpnessThreshold",
                        "Biometry|OnboardingSelfieSharpnessThreshold",
                        "Biometry|OnboardingSelfieCandidateSelectionDuration",
                        "Biometry|OnboardingDocumentCandidateSelectionDuration"
                    ]);

                    // Kontrola nastavenia premennych - profile-extra
                    main.checkSettings("profile-extra", [
                        "QuickBets|HomePage",   // Zobrazenie buttonu QuickBetu na home obrazovke
                        "QuickBets|Live",       // Zobrazenie buttonu QuickBetu v LIVE (bez vyberu sportu)
                        "QuickBets|Sport",      // Zobrazenie buttonu QuickBetu v LIVE pri vybranom sporte (podla QuickBets.SportID)
                        "QuickBets|IsNew",      // Zobrazenie QuickBet buttonov s textom "NOVINKA"
                        "QuickBets|VideoOnTop", // Zobrazenie QuickBet na vrchnej obrazovke
                        "QuickBets|SportID",    // SportID pre QuickBet (pre zobrazenie spravnej ikonky a Quickebt buttonu pri spravnom sporte)
                        "QuickBets|SportName",  // SportName preklad v sb adminovi
                        "QuickBets|Img",        // Url pozadia QuickBet buttonu
                        "QuickBets|UrlControls", // Url iframe QuickBetov
                        "QuickBets|UrlVideo",     // Url iframe QuickBetov - len video
                        "QuickBets|BalanceAutoAdd"     // QuickBet Prepínač - výhry pripisovať k zostatku
                    ]);

                    // Kontrola nastavenia premennych - profile-extra
                    main.checkSettings("profile-extra", [
                        "Lottery|RegionID",       // RegionID urceny pre loteriove hry
                        "Lottery|Providers",      // Povoleny providers pre loteriove hry
                        "Lottery|ShortcutBets"    // Nastavenie vkladov v kalkulacke
                    ]);

                    if (offer.live) {
                        // Povolenie LIVE
                        offer.live = true;
                        $("#homeButtons .ui-block-a, #footer #f3").removeClass("ui-disabled pointer-active");
                    } else {
                        // Blokovanie LIVE
                        offer.live = false;
                        $("#homeButtons .ui-block-a, #footer #f3").addClass("ui-disabled pointer-active");
                    }

                    // Zobrazenie meny
                    if (profile.Currency)
                        $(".ticket-header__balance .ticket-header__item--balance").text(shared.floor2(stored.Balance, 1) + " " + profile.Currency);

                    // Zobrazenie tlactika "WINY" v kalkulacke ak su zapnute
                    if (profile.IsWinCurrency && !profile.LotteryAllowed) {
                        document.querySelector("#displayDial").classList.add("deposit-dial__display--is-win-currency");
                    }

                    // Zobrazenie verzie aplikacie
                    if (profile.Version) {
                        profile.VersionSbApp = $("head meta[name='version']").attr("content");
                        $("#more #version span").eq(1).text(" v" + profile.Version + " (" + profile.VersionSbApp + ")");
                    }

                    // Nastavenie Google Analytics 4 a globalnych parametrov (SBID, app_name, app_version)
                    if (profile.GTagID) {
                        $("head").append(`
                            <script async type="text/javascript" src="https://www.googletagmanager.com/gtag/js?id=${profile.GTagID}"></script>
                            <script>
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', profile.GTagID, {'sportbox_id': stored.SBID, 'app_name': 'Sportbox', 'app_version': stored.NativeAppVersion, 'webapp_version': '${stored.WebAppVersion}'});
                            </script>
                        `);
                        // Globalny atribut verzie web app pre kazdy dalsi event.
                        gtag('set', {'webapp_version': stored.WebAppVersion});
                    } else {
                        // fallback - Vypnutie Google Analytics ak by nebolo profile.GTagID nastavene. - gtag() sa v kode stale vola
                        gtag = function(){return false};
                    }

                    // Nastavenie CSS zdroja podla verzie aplikacie
                    if (!profile.FlatCSS) {
                        // Nepouziva sa - original css verzia bola odstranena
                        var versionCSS = $("head meta[name='css-original-version']").attr("content");
                        $("head").append('<link id="originalCSS" rel="stylesheet" type="text/css" href="stylesheets/sportbox-original-' + versionCSS + '.css"/>');
                        $('#doxxbetTerms .flat-design').css('display', 'none');
                        setTimeout(function () {
                            $("head").find("#flatCSS, #iconsCSS").remove();
                        }, 500);
                    }

                    // Pre retail verziu zapne kurzor
                    if (profile.IsRetail) {
                        $("body").addClass("retail");
                    }

                    profile.Biometry.FrontCamera = profile.Biometry.FrontCamera? "user": "environment";
                    if (ticket.playerNotAllowedForBetting()) {
                        if (profile.BiometryLogin && profile.Biometry.BatchCount) {
                            player.biometryButton(true);
                        } else {
                            player.biometryButton(false);
                        }
                    } else if (stored.PlayerID) {
                        $("#unlockSB, #biometryLogin, #biometryRegister").hide();
                    } else if (profile.BiometryLogin && profile.Biometry.BatchCount) {
                        player.biometryButton(true);
                    } else {
                        $("#unlockSB, #biometryLogin, #biometryRegister").hide();
                    }

                    // Zobraz button registracie pomocou biometrie
                    if (profile.BiometryOnboarding && !stored.PlayerID) $("#biometryRegister").show();

                    if (profile.Resolution === "1280x1024") {
                        // 1280x1024 s QuickBets
                        if (profile.QuickBetsAllowed && profile.QuickBets.HomePage) {
                            offer.maxEventsOfDay = 7;
                        } else {
                            offer.maxEventsOfDay = 8;
                        }
                    } else {
                        // ~FHD bez QuickBets
                        if (profile.QuickBetsAllowed && profile.QuickBets.HomePage) {
                            offer.maxEventsOfDay = 6;
                        } else {
                            offer.maxEventsOfDay = 7;
                        }
                    }
                    // Nastavenie Quickebetov
                    quickbet.setQuickBetButtons(profile.QuickBetsAllowed);

                    // Nastavenie VirtualGames
                    if (profile.VirtualGames) {
                        // Zobrazenie VirtualGames
                        if (offer.live) {
                            // Povolenie VirtualGames
                            offer.virtualGames = true;
                            $("#homeButtons .ui-block-d, #footer #f8").removeClass("ui-disabled pointer-active");
                        } else {
                            // Blokovanie VirtualGames
                            offer.virtualGames = false;
                            $("#homeButtons .ui-block-d, #footer #f8").addClass("ui-disabled pointer-active");
                        }

                        if (profile.Resolution === "1280x1024") {
                            // Pre rozlisenie "1280x1024" vypne zobrazenie VirtualsOctava
                            profile.VirtualsOctava = false;
                        }
                    } else {
                        // Skrytie VirtualGames
                        offer.virtualGames = false;
                    }

                    // Nastavi preklady (musi byt prvy)
                    main.setLabels();

                    // Nastavi jednotlive URL na sluzby, v pripade neuspechu restartuje APP
                    if (main.setURLs()) {

                        // Nastavi zobrazenie virtualGames/Loteriovych hier
                        home.set4thHomeButton();

                        // Nastevenie zobrazenia sekcii "Herny plan" a DOXXbet klub
                        more.menu.setProperties(profile.Terms, profile.GDPR, profile.Bonuses, profile.Club, profile.ClubHomeButton, profile.ClubNew, profile.ClubCompetition);

                        // Inicializacia na ticketWS (#5)
                        ticket.ticketTypeSwitch(ticket.state.ticketWsTypes.JT);
                        ticket.ticketWsRetrieve();

                        // Nastavi gamepart preklady pre aktualny jazyk
                        if (offer.offerGameParts) shared.getGameParts();

                    } else {
                        main.startApp(1);
                    }

                    main.createLog(3, "SettingConfiguration", "Sportbox webApp version: " + profile.VersionSbApp);
                    // Informacia o verzii SB webApp sa posiela na nativeApp
                    if (!stored.browser) WebApplicationInfo(profile.VersionSbApp);

                    // Init setup pre QuickBet Prepínač - výhry pripisovať k zostatku
                    stored.QuickBetSwitchBalanceAutoAdd = profile.QuickBets.BalanceAutoAdd;
                    $("#quickBetSwitchBalanceAutoAdd").attr("checked", stored.QuickBetSwitchBalanceAutoAdd);

                }, 0);
                return true;

            } else {
                main.startApp(1);
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.startApp(1);
            return false;
        }
    },

    // Funkcia na ziskanie referencneho casu (docasne platna funkcia - kym je spustena offera s neoptimalizovanou cache)
    setClock: function(callback) {
        try {
            var requestUrl;
            $.getJSON(requestUrl = url.offer + "TimeStamp/Zone/" + offer.zone + "?callback=?")
                .done(function (time) {
                    if (callback) {
                        callback(time);
                        return true;
                    } else if (time = new Date(time).getTime()) {
                        // Nastavi cas pre danu casovu zonu a spusti hodiny
                        stored.time = time - new Date().getTime();
                    }
                    // Spusti hodiny
                    main.clock();
                    return true;

                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    setTimeout(function () {
                        main.setClock(callback);
                        return false;
                    }, sets.refreshTime);
                });

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            setTimeout(function () {
                main.setClock(callback);
                return false;
            }, sets.refreshTime);
        }
    },

    // Funkcia na ziskanie referencneho casu (oddscache offera)
    setClockOddsCache: function(callback) {
        try {
            var requestUrl;
            requestUrl = url.offer + "TimeStamp/Zone/" + offer.zone;
            $.ajax({
                type: "GET",
                url: requestUrl,
                timeout: sets.submitTimeout + stored.BuyBackDelay,
                async: true
            })
                .done(function (time) {
                    if (callback) {
                        callback(time);
                        return true;
                    } else if (time = new Date(time).getTime()) {
                        // Nastavi cas pre danu casovu zonu a spusti hodiny
                        stored.time = time - new Date().getTime();
                    }
                    // Spusti hodiny
                    main.clock();
                    return true;
                })
                .fail(function (jqXHR) {
                    jqXHR.requestUrl = requestUrl;
                    setTimeout(function () {
                        main.setClockOddsCache(callback);
                        return false;
                    }, sets.refreshTime);
                })
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            setTimeout(function () {
                main.setClockOddsCache(callback);
                return false;
            }, sets.refreshTime);
        }
    },

    // Funkcia hodiny
    clock: function(noSec) {
        try {
            clearTimeout(rfs.clock);

            // Nastavi aktualny date (s casovym posunom - stored.time)
            if (stored.time) {
                today = new Date(new Date().getTime() + stored.time);
            } else {
                today = new Date();
            }

            // Ulozi aktualnu hodinu a datum (vratane casoveho posunu)
            offer.actualHour = today.getHours();
            offer.dateTD = today.getFullYear() + "-"
                + ("0" + (today.getMonth() + 1)).slice(-2) + "-"
                + ("0" + today.getDate()).slice(-2);

            // Ulozi zajtrajsi datum (vratane casoveho posunu)
            tomorrow = new Date(today);
            new Date(tomorrow.setDate(today.getDate() + 1));
            offer.dateTM = tomorrow.getFullYear() + "-"
                + ("0" + (tomorrow.getMonth() + 1)).slice(-2) + "-"
                + ("0" + tomorrow.getDate()).slice(-2);

            // Vykresli datum a cas
            $("#sportBox .header-date").text(offer.dateTD.substr(8, 2) + "." + main.setMonth(offer.dateTD.substr(5, 2), true) + offer.dateTD.substr(0, 4));
            $("#sportBox .header-time").text(("0" + offer.actualHour).slice(-2) + ":" + ("0" + today.getMinutes()).slice(-2));

            // Nastavi ikonky na home obrazovke
            if (stored.dateTD != offer.dateTD) home.setHomeIcons();

            // Ide kazdu sekundu a ked sa synchronizuje tak ide po minute
            if (noSec && today.getSeconds() == 0) {
                rfs.clock = setTimeout('main.clock(true)', 60000);
            } else {
                rfs.clock = setTimeout('main.clock(true)', 1000);
            }

            if (stored.WarnInfo.endDate && (today.getTime() >= new Date(stored.WarnInfo.endDate).getTime())) {
                // Ak existuje objekt s warning hlaskou tak ju vymaze a hlasku skryje
                stored.WarnInfo = new Object();
                home.homeWarningToggle(false);
            }

            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Preklady pre mesiace
    setMonth: function(month, monthTranslate, fullName) {
        try {
            if (monthTranslate) {
                switch (offer.lang) {
                    case 'sk':
                        month = ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'][month - 1];
                        break;
                    case 'cs':
                        month = ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Záři', 'Říjen', 'Listopad', 'Prosinec'][month - 1];
                        break;
                    default:
                        month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][month - 1];
                        break;
                }
                if (!fullName) month = month.substring(0, 3);
                month += " ";
            } else {
                month += ".";
            }
            return month;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zmena jazyka sportboxu
    changeLang: function(lang, userTrigger) {
        // meranie do GA4 - zmena jazyka uzivatelom
        gtag('event', 'language_change', {'language_change_fromto': offer.lang + ':' + lang});
        if (userTrigger && stored.PlayerID) {
            // Ak sa jedna o prihlaseneho uzivatela ulozi jeho zvoleny jazyk
            offer.lang = stored.UserSettings.Modified.playerLanguage = lang;
            // TODO: pri prihlasenom hracovi nativeApp zavola languageLabels(args)
            player.playerSettingsModule.modifyUserSettingsObject("playerLanguage", lang, "user");
            player.playerSettingsModule.modifyUserSettingsObject("allowedRateChangePlayer", stored.UserSettings.Modified.allowedRateChangePlayer);
            player.playerSettingsModule.userSettingsPreserve(true, 'changeLang');
            main.closeDialog();
            return true;
        }
        communication.statsTable(false);
        player.incomeSourcesModule.getPossibleIncomeSources();
        main.closeDialog();
        try {
            if (typeof SetPlayerLanguage === "function") {
                // Volanie na nativ app, ktoré nakoniec zavolá languageLabels(languageID, json, initiator) (jazyk, preklady, vráti z volania "user")
                SetPlayerLanguage(lang, "user");
            } else {
                // Volanie z browsera, vyziadanie prekladov zo sb-admin TranslationApi
                main.requestTranslations(lang);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            setTimeout(function () {
                window.location = url.base;
            }, 1000);
            return false;
        }
    },

    /**
     *
     * Funkcia na logovanie do nativeApp
     *
     * @param logSev    0 = OK (unlockSB), 1 = error (lockSB), 2 = warning, 3 = info
     */
    createLog: function(logSev, logTrans, logInfo) {
        if (!logInfo) logInfo = "";

        setTimeout(function () {
            try {

                WebAppError(logSev, logTrans, logInfo);
                return true;

            } catch (e) {
                console.warn("logSev: " + logSev + " logTrans: " + logTrans + " logInfo: " + logInfo);
                return false;
            }
        }, 0);

        // TODO: profile je standardne nativna funkcia prehliadaca, treba kontrolu typu (alebo zmenu nazvu objektu)
        if (typeof profile === 'object' && (profile.ConsoleLog || profile.ConsoleLog$.createLog)) console.log("!   createLog"
            + " -> logSev: " + logSev
            + " | logTrans: " + logTrans
            + " | logInfo: " + logInfo
        );
    },

    // Funkcia zobrazujuca odpocet v loaderi
    countdown: function(sec) {
        try {
            clearInterval(ct.countDown);
            ct.countDown = null;
            $(".countdown").remove();
            if (sec) {
                sec = parseInt(sec);
                $(".ui-icon-loading").html('<span class="countdown">' + sec + '</span>');
                if (sec > 9) $(".countdown").addClass("double");
                ct.countDown = setInterval(function () {
                    sec--;
                    if (sec > 9) {
                        $(".countdown").addClass("double").text(sec);
                    } else if (sec > 0) {
                        $(".countdown").removeClass("double").text(sec);
                    } else {
                        main.countdown();
                    }
                }, 1000);
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Zamknutie sportboxu
    lockApp: function(timer, reason, theme, count) {
        try {
            stored.lockedApp = true;
            main.stopLock();
            if (timer == -1) {

                // Zamknutie pri uvodnej synchronizacii
                $("body").addClass("ui-disabled sync-lock");
                setTimeout(function () {
                    $.mobile.showPageLoadingMsg("a", reason, true);
                }, 0);

            } else if (!$("body").hasClass("sync-lock")) {
                // Standartne zamknutie
                $("body").addClass("ui-disabled locked transparent");

                // Nastavi cas za ktory sa ma zasednut obrazovka a nanovo nacitat App, berie do uvahy podavanie tiketu
                ct.lock = setTimeout(function () {
                    $("body").removeClass("transparent");
                    // Aplikacia sa restartuje 5 sekund po zasednuti (ak sa medzi tym neodomkne)
                    ct.loctRestart = setTimeout(function () {
                        window.location = window.location.href;
                    }, sets.heartBeat);
                }, stored.darkScreen);
                if (reason) {

                    // Zamknutie pocas behu aplikacie - uvedeny dovod problemu
                    if (!theme) theme = "a";
                    $.mobile.showPageLoadingMsg(theme, reason, true);

                } else {

                    // Zamknutie pocas behu aplikacie - napr. podanie tiketu
                    modal.showLoading(count);
                }

                // Automaticke odomknutie za zvoleny cas
                if (timer && timer != 0) ct.unlock = setTimeout(function () {
                    main.unlockApp();
                }, timer * 1000);

            } else {

                // Ak je zamknuty koli synchronizacii a je ziadost o standartne zamknutie
                $("body").addClass("locked");
            }

            return true;
        } catch (e) {
            return false;
        }
    },

    // Odomknutie sportboxu (automaticky hideLoading)
    unlockApp: function(synced) {
        try {
            main.stopLock();
            if (synced) {
                $("body").removeClass("sync-lock");

            } else {
                $("body").removeClass("locked");
            }

            if (!$("body").hasClass("sync-lock") && !$("body").hasClass("locked")) {
                $("body").removeClass("ui-disabled transparent");
                $.mobile.hidePageLoadingMsg();
                stored.lockedApp = false;
                main.countdown();
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.startApp(1);
            return false;
        }
    },

    // Vymaze timer na zamknutie a odomknutie
    stopLock: function() {
        try {
            clearTimeout(ct.lock);
            clearTimeout(ct.unlock);
            clearTimeout(ct.loctRestart);
            ct.lock = ct.unlock = ct.loctRestart = null;
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Tlactiko na spustenie ADMIN modu
    adminMode: function() {
        main.closeDialog();
        // Zrusim pripadne zobrazovanie streamu
        stream.streamEnd();
        setTimeout(function () {
            try {
                AdminMode();
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
        }, 500);
    },

    // Funkcia uzivatelskej aktivity na SB
    userAction: function(init, isTicketDetailAction) {
        try {
            if (player?.onboarding?.inProgress && !player?.onboarding?.playerIsViewingLegalDocs) {
                // Uplynul timeout pocas onboardingu (hrac nezobrazuje legal docs)
                clearTimeout(rfs.ticketWatcher);
                rfs.ticketWatcher = null;
                return false;
            }
            if (!stored.actionsHandling.tooltipMousedown) modal.hideTooltip();
            clearTimeout(rfs.watcherTicketDetail);
            rfs.watcherTicketDetail = null;
            clearTimeout(rfs.watcher);
            // V ConsoleLog rezime sa vypne watcher a watcherTicketDetail
            if (!profile.ConsoleLog && !profile.ConsoleLog$.WatcherOff) {
                if (isTicketDetailAction || stored.OriginalInputGUID || stored.tempInputGUID) {
                    // Watcher pre tiket detail sa spusta len pokial sa jedna o aktivitu suvisiacu s detailom tiketu
                    rfs.watcherTicketDetail = setTimeout('main.watcherTicketDetail()', sets.watcherTicketDetailTime);
                }
                var watcherTimeout = sets.watcherTime;
                // Ak je prihlaseny alebo PlayerID = -10; manualne overeny, nie pod svojim kontom ale prihlaseny obsluhou
                if (stored.PlayerID) { 
                    watcherTimeout = sets.watcherTime - sets.watcherTimePlayerNotify;
                }
                rfs.watcher = setTimeout('main.watcher()', watcherTimeout);
            }

            // Zastavenie procesu prechodu do standby pri rozpracovanom tikete
            if (rfs.ticketWatcher) {
                clearTimeout(rfs.ticketWatcher);
                rfs.ticketWatcher = null;
                modal.hideLoading();
                modal.hideErr(true, "WatcherCancelAction");
            }

            // Obnovenie pripojenia na signalR hub pri aktivite uzivatela
            if (init && (!connection || (connection.state === signalR.HubConnectionState.Disconnected))) {
                if (offer.signalrView.length) {
                    // Ak je signalR odpojene a zaroven ma byt zapnute (signalR view je nastavene) prebehne opatovna inicializacia
                    events.eventsSignalrModule.initSignalR();
                }
                // Pri oziveni obrazovky zobrazi pripadne info lokalnej sutaze
                if (profile.LocalCompetition) {
                    var player = -1;
                    if (stored.PlayerID) player = stored.PlayerID;
                    communication.topScreen('localCompetition', {competition: profile.LocalCompetition.toLowerCase(), playerID: player});
                }
            }

            // Zastavenie refreshu pre startPage a ticketRecovery
            main.startPageRefresh(false);
            ticket.ticketRecovery(false);

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Watcher sleduje neaktivitu SB, po 1.5 minute zatvori detail tiketu (nezalezi ci je Player prihlaseny)
    watcherTicketDetail: function() {
        try {
            rfs.watcherTicketDetail = null;
            if (dialog.isOpen("ticketStatusDialog")) {
                // Zatvori detail tiketu
                ticketDetail.clearTicketStatus(true);
                main.closeDialog();
            } else if (stored.tempInputGUID && offer.eventID) {
                // Zatvori detail zapasu otvoreny z detailu tiketu (Detail tiketu sa automaticky otvara po zatvoreni detailu zapasu)
                main.closeDialog();
                setTimeout(function() {
                    // Nasledne zatvori detail tiketu
                    stored.tempInputGUID = null;
                    ticketDetail.clearTicketStatus(true);
                    main.closeDialog();
                }, 0);
            }
            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            setTimeout(function () {
                main.watcherTicketDetail();
            }, sets.refreshTime);
            return false;
        }
    },

    // Watcher sleduje neaktivitu SB, po 3 minutach vrati na home a vymaze tiket
    watcher: function() {
        try {
            rfs.watcher = rfs.ticketWatcher = null;

            // po timeout zavolam funkciu, ktora vola native app ak je zatvorene "gdpr" alebo "terms" okno
            // rozhodovanie riesim vo funkcii
            // momentalne sa pouziva iba pri onboardingu
            if (player?.onboarding?.inProgress && player?.onboarding?.playerIsViewingLegalDocs) {
                // Uplynul timeout pocas onboardingu (hrac zobrazuje legal docs)
                legalDocs.hidden("watcherTimeout");
                main.watcherAction(list.Count == 0 && !stored.PlayerID);
                return false;
            }

            var watcherTimeout = sets.showHomeScreen;

            // Ak ma prazdny tiket a zaroven nie je prihlaseny
            if (!player?.onboarding?.inProgress) {
                if (list.Count == 0 && !stored.PlayerID) {
                    main.watcherAction(true);
                } else {
                    if (stored.PlayerID) {
                        // Ak ma rozpracovany ticket a je prihlaseny (PlayerID = -10; manualne overeny, nie pod svojim kontom ale prihlaseny obsluhou)
                        watcherTimeout = sets.watcherTimePlayerNotify;
                        modal.toggleAutoLogOffPlayerModal(true);
                    } else {
                        // Ak ma rozpracovany tiket a nie je prihlaseny tak mu da moznost zastavit proces prechodu do standby
                        modal.showLoading(sets.showHomeScreen / 1000, true);
                        modal.showErrObj(1, sets.showHomeScreen / 1000, {err1: texts.WatcherCancelAction, err2: texts.WatcherTicketCancel, errType: "WatcherCancelAction"});
                    }
                    rfs.ticketWatcher = setTimeout(function () {
                        main.watcherAction(false);
                    }, watcherTimeout);
                }
            }

            return true;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            setTimeout(function () {
                main.watcher();
            }, sets.refreshTime);
            return false;
        }
    },

    /**
     * Akcia po watcher timeoute (neaktivite hraca s rozpracovaným tiketom)
     *
     * @param {boolean} [isAnonymousEmptyTicket] - True, ak je tiket prázdny a hráč nie je prihlásený (anonymný).
     */
    watcherAction: function(isAnonymousEmptyTicket) {
        // Ak je aktivny onboarding, neriesi sa aktivita uzivatela (neaktivitu uzivatela manazuje nativeApp)
        if (player?.onboarding?.inProgress) {
            return false;
        }
        if (!isAnonymousEmptyTicket) {
            modal.hideInfoModal();
        }
        // Prejde na start page a zaroven zatvoreny prapadne otvorene dialogove okno
        main.setPage(profile.startPage, true);
        // Skryje otvorenu informacnu hlasku
        modal.hideErr(true);
        main.startPageRefresh(true);
        if (!isAnonymousEmptyTicket) {
            ticket.ticketClear(true, true);
        }
        ticket.ticketRecovery(true);
        events.eventsSignalrModule.stopSignalR();
        player.moneyBack();
        modal.hideTooltip();
        if (stored.AllowedRateChange !== profile.AllowedRateChangeDefault) {
            ticket.allowedRateChange(profile.AllowedRateChangeDefault);
        }
        if (ticket.state.getState().isEditTicket) {
            ticket.ticketWsReset(true);
        }
        if (offer.lang !== profile.LanguageIdDefault) main.changeLang(profile.LanguageIdDefault, false);
    },

    /**
     * Prepne stránku (filter) vo footri
     *
     * @param {number} f - Číslo stránky, na ktorú sa má prepnúť
     * @param {boolean} [forceCloseDialog] - Príznak, či vynútiť zatvorenie dialógového okna
     * @returns {boolean} Úspech/neúspech vykonania funkcie
     */
    setPage: function(f, forceCloseDialog) {
        try {
            // Vyuziva sa vo funkcii ticket.ticketOddModule.setLogOdd()
            offer.homeButtonUsed = false;

            // Zrusenie hornej obrazovky
            communication.topScreenClose();

            // Zrusenie odpoctu LIVE zapasov
            service.liveCountDownClear();

            // GA4 - reset ulozeneho filtra pre document.title po zmene screen
            stored.screenFilter = "";

            // Zrusenie inline detailu zapasu (v pripade prechodu na inu stranku z virtualnych hier)
            // Alebo s nastavenym forceCloseDialog (ak sa jedna o vynuteny setPage z dovodu neaktivity hraca)
            if (offer.eventID || forceCloseDialog) main.closeDialog();

            $("#tableBottom .arrows").hide();
            $("#tableTop .table-icon").removeClass().addClass("table-icon");
            $("#eventsIframeWrapper").hide().empty();
            clearTimeout(rfs.LotteryGameSendDataTimer);

            $("#events #noEvents").removeClass();
            // Skryje informacnu hlasku v LIVE
            $("#pageActualisationInfo").hide();

            // Zobrazi hlasku o nedostupnosti sluzby
            if (!offer.live && (f == 3 || (profile.VirtualGames && f == 8))) {
                switch (f) {
                    case 3:
                        modal.showErrObj(2, 5, {err1: texts.LiveBlocked, errType: "LiveBlocked"});
                        break;
                    case 8:
                        modal.showErrObj(2, 5, {err1:texts.ServiceBlocked, errType: "ServiceBlocked"});
                        break;
                }
            } else {
                $("#footer").addClass("lock-btn");
                // zakazujeme klikanie na plachtu a na ponuku pri prechode na inu "stranku" aby pri pomalom pripojeni a besnom tapkani nedochadzalo k requestom
                $("#sportsBook, #events").addClass("ui-disabled");
                $("#showAllEvents").hide();
                if (f != 1) {
                    $("#events #noEvents").show();
                    $("#events #section").empty();
                    $("#tableTop .table-title").empty();
                }
                //if (f != 7) $("#setVolume").hide();

                offer.onlyLive = -1;
                offer.date = -1;

                if (profile.ExtendedOffer) {
                    $('#sportBox .content-table').parent().removeClass('is-fat-menu').addClass('is-narrow-menu');
                    stored.ExtendedActualOffer = true;
                } else {
                    $('#sportBox .content-table').parent().removeClass('is-narrow-menu').addClass('is-fat-menu');
                    stored.ExtendedActualOffer = false;
                }
                // Prepne na zvolenu stranku
                switch (f) {
                    case 1:
                        // Home Screen
                        offer.page = "home";
                        stored.isMatchesFilterActive = false;
                        events.eventsCompetitionModule.clearJackpots();
                        service.loadPure('home');
                        // Popisky
                        $("#headerTitle").html('<div id="logo" class="logo-cursive-' + offer.country + '"></div>');
                        $("#offerTop").empty();
                        quickbet.showQuickBetButton("", true);
                        break;
                    case 2:
                        // All Offer - ROOT
                        offer.page = "sportsBook";
                        stored.isMatchesFilterActive = false;
                        events.eventsCompetitionModule.clearJackpots();
                        service.loadPure('sportsBook');
                        // Popisky
                        $("#offerTop").empty();
                        $("#tableTop .table-overall-title").empty();
                        $("#events #noEvents h1").html(texts.OfferMsgT);
                        $("#events #noEvents .message").html(texts.OfferMsg);
                        quickbet.showQuickBetButton("", true);
                        break;
                    case 3:
                        // Only Live Offer - ROOT
                        offer.page = "onlyLive";
                        offer.onlyLive = 1;
                        stored.isMatchesFilterActive = false;
                        events.eventsCompetitionModule.clearJackpots();
                        service.loadPure('sportsBook');
                        // Popisky
                        $("#tableTop .table-overall-title").text(texts.FooterLabelLive);
                        $("#offerTop").empty();
                        $("#events #noEvents h1").html(texts.OfferMsgT);
                        $("#events #noEvents .message").html(texts.OfferMsgLive);
                        break;
                    case 4:
                        // Starting Matches (LastMinute)
                        offer.sportID = 0;
                        offer.page = "lastMinute";
                        stored.isMatchesFilterActive = true;
                        events.eventsCompetitionModule.clearJackpots();
                        sportsbook.renderFilterForMatches();
                        sportsbook.matchesFilter(offer.lastMinute, offer.lastMinuteHours.indexOf(offer.lastMinute));
                        if (profile.FlatCSS) {
                            $("#offerTop").empty();
                        }
                        $("#tableTop .table-overall-title").text(texts.FooterLabelStartingMatches);
                        quickbet.showQuickBetButton("", true);
                        break;
                    case 5:
                        // Today
                        offer.page = "today";
                        offer.date = "TD";
                        stored.isMatchesFilterActive = false;
                        events.eventsCompetitionModule.clearJackpots();
                        service.loadPure('sportsBook');
                        // Popisky
                        $("#tableTop .table-overall-title").text(texts.FooterLabelToday);
                        $("#offerTop").empty();
                        $("#events #noEvents h1").html(texts.OfferMsgT);
                        $("#events #noEvents .message").html(texts.OfferMsgToday);
                        quickbet.showQuickBetButton("", true);
                        break;
                    case 6:
                        // Next days
                        offer.page = "otherDates";
                        offer.sportID = 0;
                        stored.isMatchesFilterActive = true;
                        events.eventsCompetitionModule.clearJackpots();
                        sportsbook.renderFilterForMatches();
                        sportsbook.matchesFilter(sportsbook.getDateAfterDays(offer.otherOfferDates[0]).replace(/-/g,''), 0);
                        if (profile.FlatCSS) {
                            $("#offerTop").empty();
                        }
                        $("#tableTop .table-overall-title").text(texts.FooterLabelOtherDates);
                        quickbet.showQuickBetButton("", true);
                        break;
                    case 7:
                        // Results
                        if (profile.Results) {
                            offer.page = "results";
                            offer.sportID = 0;
                            stored.isMatchesFilterActive = true;
                            events.eventsCompetitionModule.clearJackpots();
                            sportsbook.renderFilterForMatches();
                            sportsbook.matchesFilter(sportsbook.getDateAfterDays(offer.resultsDates[3]).replace(/-/g,''), 3);
                            // Popisky
                            $("#offerTop").empty();
                            $("#tableTop .table-overall-title").text(texts.FooterLabelResults);
                            $("#events #noEvents h1").html(texts.OfferMsgT);
                            $("#events #noEvents .message").html(texts.OfferMsgResults);
                        } else if (profile.LotteryAllowed) {
                            offer.page = "lotteryGames";
                            stored.isMatchesFilterActive = false;
                            events.eventsCompetitionModule.clearJackpots();
                            // Vykresli loteriove hry
                            service.loadPure("lotteryGames");
                            // Vycisti plachtu a vrchnu listu nad plachtou
                            $("#offerTop, #tableTop .table-overall-title").text("");
                            $("#events #noEvents h1, #events #noEvents .message").html("");
                        }
                        quickbet.showQuickBetButton("", true);
                        break;
                    case 8:
                        quickbet.showQuickBetButton("", true);
                        if (profile.VirtualGames) {
                            // VirtualGames - ROOT
                            offer.page = "virtualGames";
                            stored.isMatchesFilterActive = false;
                            events.eventsCompetitionModule.clearJackpots();
                            service.loadPure('virtualGames');
                            $("#offerTop").text(texts.HeaderLabelVirtualGames);
                            $("#tableTop .table-overall-title").text(texts.FooterLabelVirtualGames);
                            $("#events #noEvents h1").html(texts.OfferMsgVirtualT);
                            $("#events #noEvents .message").html(texts.OfferMsgVirtual);
                            break;
                        }
                    // Ak su virtulky vypnute tak prejde na case 9
                    case 9:
                        // PopularLeagues All Offer - LEAGUES
                        offer.page = "popularLeagues";
                        stored.isMatchesFilterActive = false;
                        events.eventsCompetitionModule.clearJackpots();
                        service.loadPure('popularLeagues');
                        // Popisky
                        if (!profile.FlatCSS) {
                            // Popisky
                            $("#tableTop .table-icon").removeClass().addClass("table-icon");
                            $("#offerTop").text(texts.HeaderLabelPopular);
                        }
                        $("#tableTop .table-overall-title").text(texts.FooterLabelPopular);
                        $("#events #noEvents h1").html(texts.OfferMsgPopularT);
                        $("#events #noEvents .message").html(texts.OfferMsgPopular);
                        break;
                }
                // Skryje hlasku 'vyberte si sport'
                if (offer.nonSportOffer.includes(offer.page) || offer.page === "virtualGames") {
                    $("#events #noEvents").hide();
                }
                // Zasvieti stlacene tlacitko
                $("#footer .footer__nav-item--active").removeClass("footer__nav-item--active");
                $("#footer #f" + f).addClass("footer__nav-item--active");
                
            }
            try {
                // Nastavenie document.title podla screen a poslanie eventu do GA4
                communication.dataTrackModule.setTitle();
                // Trackovanie zobrazenia screen po akcii hraca a nie automaticky po timeout watchera
                if (event?.type === "mousedown") {
                    gtag('event','screen_view', {'screen_name': offer.page})
                }
                if (profile.IsWinCurrency) {
                    ticket.ticketWinCurrencyModule.updateWinCurrencyClientBalance();
                }
            } catch (error) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments) + "Error: " + error);
            }

            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Obnova obsahu 'startPage' stranky v case uzivatelskej neaktivity
    startPageRefresh: function(run) {
        try {
            clearInterval(rfs.startPage);
            if (run) {
                rfs.startPage = setInterval(function () {
                    cache = {};
                    switch (profile.startPage) {
                        case 1:
                            service.loadPure('home', null, true);
                            break;
                        case 5:
                            service.loadPure('popularLeagues', null, true);
                            break;
                        case 8:
                            service.loadPure('virtualGames', null, true);
                            break;
                        default:
                            service.loadPure('sportsBook', null, true);
                            break;
                    }
                }, sets.startPageRefresh);
            } else {
                rfs.startPage = null;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Funkcia na vynutie zamknutie SB
    lockSB: function(statusText) {
        var jqXHR = new Object();
        jqXHR.status = 450;
        jqXHR.statusText = statusText;
        service.ajaxFailed(jqXHR);
    },

    // Spojenie so serverom funguje alebo prebieha deploy App
    unlockSB: function() {
        try {

            // Ak je SB zamknuty alebo sa prvy krat spusta, tak ho odomkne
            if (stored.lockedSB || typeof stored.lockedSB == "undefined") {

                // Zastavi kontrolu spojenia
                clearInterval(rfs.reconnecting);

                // Vymaze jqXHR -> keby ho nevymazal tak by sa pri rovnakej strate spojena SB nezablokoval
                stored.jqXHR = rfs.reconnecting = ct.reconnecting = null;
                stored.lockedSB = false;

                // Spojenie so servrom opatovne nadviazane (pokial sa nejedna o start APP)
                if (!ct.initWebApp) {

                    // Obnovenie tiketu
                    if (list.Odds.length) service.loadPure('ticket');

                    // Simulovana akcia uzivatela
                    main.userAction();

                    // Ak bol tiket na schvalovani pri strate spojenia tak na to upozorni
                    if (stored.GUID == "onApprove") {
                        stored.GUID = stored.BonusMoney = null;
                        modal.showErrObj(1, 5, {err1: texts.ConnectionErr, err2: texts.TicketErr08, errType: "ConnectionErr"});
                    }

                } else {
                    // Nanovo spusti aplikaciu
                    main.startApp(1);
                }

                // Odomkne SB
                main.unlockApp(true);
                main.createLog(0, "ConnectionOK");

                return true;

            } else if (stored.lockedApp) {
                // Jedna sa o odomknutie SB v pripade ze pocas startu nastal ajax timeout/timeouty, ale nezablokovali web app.
                // Situacia: podarilo sa pocas startu obnovit spojenie, ale existuje zamknutie pri uvodnej synchronizacii
                main.unlockApp(true);
                // Nastavenie obnovovania stranky pri uzivatelskej neaktivite
                main.startPageRefresh(true);
            }
            return false;

        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            main.startApp(1);
            return false;
        }
    },
    // Funkcia, ktora nastavi popisky v GUI
    setLabels: function(lang) {
            try {
                // Vytvori vnorene DOM elementy pre tlacitka
                $("#ticketStatus .status-buttons").trigger("create");
    
                // Preklady pre vyber jazyka
                // Nastavi info ikonu podla jazyka
                $("#header .icon-language").removeClass("lang-sk lang-cs lang-se lang-hu lang-en lang-de lang-fr lang-pl lang-ro")
                    .addClass("lang-" + (lang? lang: offer.lang));
                if ($("#modalLanguage .ui-content").is(":empty")) {
                    var modalLanguagesContent = "<h3 class='flat-highlighted-header'></h3>";
                    profile.AvailableLanguages.forEach(function (lang) {
                        modalLanguagesContent += `
                        <a data-role="none" class="menu-lang" onmousedown="main.changeLang('${lang.code}', true);">
                            <div class="lang-img lang-${lang.code}"></div>
                            <i><span>${lang.code}</span></i>${lang.languageName}
                        </a>`;
                    });
                    $("#modalLanguage .ui-content").append(`
                        <div data-role="none">
                            ${modalLanguagesContent}
                            <a data-role="none" class="menu-close flat-highlighted-header" onmousedown="dialog.close('modalLanguage');" style="display: none;"></a>
                        </div>
                    `);
                }
                $("#modalLanguage h3").html(texts.MoreUserLanguage);
    
                // Nastavi ci sa ma zobrazovat tiket help spolu s pomocnikom pre vernostnu kartu
                stored.hasClubHelper = (profile.ClubLoyaltyCard && profile.FlatCSS);
    
                // Upravi preklady podla meny
                if (profile.Currency) {
                    texts.TicketErr04 = texts["TicketErr04_" + profile.Currency];
                    if (stored.hasClubHelper) 
                        texts.TicketHelpHasClub1 = texts["TicketHelpHasClub1_" + profile.Currency];
                    else 
                        texts.TicketHelp1 = texts["TicketHelp1_" + profile.Currency];
                }
                // Upravi preklady podla nazvu Booster bonusu
                if (profile.BoosterBonus) {
                    switch(profile.BoosterBonusName) {
                        case "XXL":
                            if (texts.XXLBonusHint) texts.BoosterBonusHint = texts.XXLBonusHint.split("{}");
                            // Odreze "XXL" pretoze nazov je tvoreny aj ikonkou
                            if (texts.CalcXXLBonus) texts.CalcBoosterBonus = texts.CalcXXLBonus.split("XXL")[1];
                            break;
                        case "Booster":
                            if (texts.BoosterBonusHint) texts.BoosterBonusHint = texts.BoosterBonusHint.split("{}");
                            break;
                    }
                }
    
                // Preklady pre header
                if (texts.HeaderLogout) texts.HeaderLogoutBR = texts.HeaderLogout.replace(" ", "<br>");
                if (texts.HeaderCashBack) texts.HeaderCashBackBR = texts.HeaderCashBack.replace(" ", "<br>");
                if (texts.HeaderCashBackLogout) texts.HeaderCashBackLogoutBR = texts.HeaderCashBackLogout.replace(" ", "<br>");
                if (texts.BiometryRegisterLabel?.length > 11) {
                    texts.BiometryRegisterLabel = texts.BiometryRegisterLabel.replace(" ", "<br>");
                }
                // Nastavi tlactiko vratit hotovost pri nulovom konte, rozhoduje sa podla sbBalance
                if (stored.PlayerID === profile.ManualVerifiedPlayerID) {
                    texts.HeaderCashBackBR = texts.HeaderLogoutManualVerifiedBR;
                } else if (stored.Balance && stored.Balance != "0" && stored.WebBalanceActive != "1") {
                    if (stored.PlayerID) {
                        texts.HeaderCashBackBR = texts.HeaderCashBackLogoutBR;
                    } else {
                        texts.HeaderCashBackBR = texts.HeaderCashBackBR;
                    }
                } else if (stored.PlayerID) {
                    texts.HeaderCashBackBR = texts.HeaderLogoutBR;
                } else {
                    texts.HeaderCashBackBR = texts.HeaderCashBackBR;
                }
                $("#moneyBack .header-right__button-label").html(texts.HeaderCashBackBR);
                $("#unlockSB .header-right__button-label").html(texts.HeaderUnlockSB);
                $("#biometryLogin .header-right__button-label").html(texts.BiometryLoginLabel);
                $("#biometryRegister .header-right__button-label").html(texts.BiometryRegisterLabel);
                $(".ticket-header__money-source-button .ticket-header__money-source-button__label").html(texts.HeaderChangeMoneySource);
                $("#submitTicket #submitTicketLabel").html(texts.HeaderBet);
                $("#submitTicket #submitEditTicketLabel").html(texts.HeaderEdit);
                [texts.HeaderBet, texts.HeaderEdit].forEach(function(textLabel, tl) {
                    if (textLabel && textLabel.indexOf("<br>") != -1) {
                        $("#submitTicket").addClass("two-rows-" + tl);
                    } else {
                        $("#submitTicket").removeClass("two-rows-" + tl);
                    }
                });
                $(".ticket-header__item--account .ticket-header__label").html(`${texts.HeaderAccount}:`);
                $(".ticket-header__item--account .ticket-header__value").html(`${stored.WebBalanceActive ? texts.HeaderAccountOnline : texts.HeaderAccountCash}`);
                $(".ticket-header__item--tips .ticket-header__label").html(`${texts.HeaderTicketTips}:`);
                $(".ticket-header__item--points .ticket-header__label").html(`${texts.HeaderPoints}:`);
                $(".ticket-header__item--win-currency .ticket-header__label").html(`${texts.HeaderWins}:`);
    
                // Preklady pre ticketStatus
                $("#ticketStatus #statusBetText").html(texts.CalcBet);
                $("#ticketStatus #statusFeeText").html(texts.CalcHandlingFee);
                if (profile.BoosterBonusName === "Booster") {
                    $("#ticketStatus #statusBoosterBonusWrapper #bonusLabelText").html(texts.CalcBoosterBonus);
                    $("#ticketStatus #statusBoosterBonusWrapper .bonus-tooltip").removeClass("icon icon-info-circle");
                } else if (profile.BoosterBonusName === "XXL") {
                    $("#ticketStatus #statusBoosterBonusWrapper #bonusLabelText").html("<span class='icon icon-logo-xxl'></span>" + texts.CalcBoosterBonus);
                    $("#ticketStatus #statusBoosterBonusWrapper .bonus-tooltip").attr("tooltip-containing-text", texts.TicketXXLBonusTooltip);
                }
                $("#ticketStatus #statusRateMultiplierText").html(texts.BonButton);
                $("#ticketStatus #statusRateText").html(texts.CalcOverallRate);
                $("#ticketStatus #ctActualWinText").html(texts.StatusActualWin);
                $("#ticketStatus #editTicketLabel").html(texts.TicketDetailEditLabel);
                $("#ticketStatus #manualRedeemTooltip #ticketRedeemNotAllowed").html(texts.StatusTicketRedeemNotAllowed);
                $("#ticketStatus #manualRedeemTooltip #manualBuyBackHeaderName").html(texts.StatusTicketRedeemHeader);
                $("#ticketStatus #manualRedeemTooltip #acceptRedeemChangesLabel").html(texts.StatusTicketRedeemAcceptChanges);
                $("#ticketStatus #autoRedeemTooltip #autoBuyBackHeaderName").html(texts.StatusAutoRedeemHeader);
                $("#ticketStatus #autoRedeemTooltip #buyBackInfo1").html(texts.StatusAutoRedeemSetInfo1);
                $("#ticketStatus #autoRedeemTooltip #buyBackInfo2").html(texts.StatusAutoRedeemSetInfo2);
                $("#ticketStatus #autoRedeemTooltip #ticketAutoRedeemSetInfo1").html(texts.StatusAutoRedeemSetInfo1);
                $("#ticketStatus #countGraphLegendLabel").html(texts.StatusGraphLegendLabel);
    
                // Preklady pre deposit display
                $("#footer-sidebar .rate-changes-btn .ui-btn-text").html(texts.RateChangeShow);
                $("#footer-sidebar .deposit-display #feeText").html(texts.CalcHandlingFee);
                if (profile.BoosterBonusName === "Booster") {
                    $("#footer-sidebar .deposit-display #bonusLabelTicket").html(texts.CalcBoosterBonus);
                    $("#footer-sidebar .deposit-display .bonus-tooltip").removeClass("icon icon-info-circle");
                } else if (profile.BoosterBonusName === "XXL") {
                    $("#footer-sidebar .deposit-display #bonusLabelTicket").html("<span class='icon icon-logo-xxl'></span>" + texts.CalcBoosterBonus).addClass("xxl-bonus");
                    $("#footer-sidebar .deposit-display .bonus-tooltip").attr("tooltip-containing-text", texts.TicketXXLBonusTooltip);
                }
                $("#footer-sidebar .deposit-display #rateText").html(texts.CalcOverallRate);
                $("#footer-sidebar .deposit-display #summaryText").html(texts.CalcWin);
                $("#footer-sidebar #betApprovement").html(texts.BetApprovement);
                $("#depositDial .deposit-dial__button--all").html(texts.CombiPanelMax);
                $("#depositDial .deposit-dial__button--currency").html(texts.HeaderWins.toUpperCase());
                $("#depositDial #betLock .ui-text").html(texts.CombiPanelBetAmmount);
                $("#depositDial #betRound").html(`${texts.CombiPanelRoundOn} <div id='betRoundValue'></div>`);
    
                // Preklady pre rucne zadavanie tiketu
                $("#searchDisplay").html(texts.ManualCalcTipEvent);
                // TODO - hotfix pre zmenu do html dialog, po odstraneni JQM TODELETE
                $("#searchDialEvent .ui-btn-text").length ? $("#searchDialEvent .ui-btn-text").html(texts.ManualCalcShow) : $("#searchDialEvent button").html(texts.ManualCalcShow);
    
                // Preklady pre typ tiketu
                $("#ticketTop #simpleLabel").html(texts.TicketTypeSimple);
                $("#ticketTop #combinedLabel").html(texts.TicketTypeCombination);
                $("#ticketTop #combinedLotteryLabel").html(texts.TicketTypeTicketLottery);
                $("#ticketTop #myTickets").html(texts.TicketAccount);
    
                // Preklady pre zadavanie tiketu
                $("#ticketTop .set-value .option-info").html(texts.SetAmount);
                $("#ticketTop .set-combinations .option-info").html(texts.ChangeTicket);
    
                // Preklady pre zadavanie vkladu (Loteriove hry)
                if (profile.LotteryAllowed && profile.Lottery.ShortcutBets && profile.Lottery.ShortcutBets.length) {
                    var lotteryShortcutButtons = "";
                    var gridButtonsChar = 0;
                    profile.Lottery.ShortcutBets.forEach(function(shortcutBet, sb) {
                        lotteryShortcutButtons += '<div class="bet-' + shortcutBet + ' ui-block-' + String.fromCharCode("a".charCodeAt(0) + sb) + '" id="bet' + shortcutBet + 'Lottery" onmousedown="stored.inputElementJustSelected = true; ticket.calc(\'' + shortcutBet + '\');"><a data-role="button" data-theme="a">' + (texts['LotteryBet-' + shortcutBet]? texts['LotteryBet-' + shortcutBet]: shortcutBet + " " + profile.Currency) + '</button></div>';
                    });
                    if (profile.Lottery.ShortcutBets.length > 2) {
                        gridButtonsChar = profile.Lottery.ShortcutBets.length - 2;
                    }
                    $("#lotteryButtonsBet").empty().removeClass().addClass("ui-grid-" + String.fromCharCode("a".charCodeAt(0) + gridButtonsChar)).append(lotteryShortcutButtons).trigger("create");
                }
    
                // Preklady pre editaciu tiketu
                $("#ticketTop #ticketForEditCodeTicketLabel").html(texts.TicketEditLabel);
                $("#ticketTop #ticketForEditCancelButton").html(texts.TicketEditCancel);
    
                // Preklady pre kontrolu tiketu - vrchna hlavna cast
                $("#ticketStatus #statusText").html(texts.StatusTicket + ": ");
                $("#ticketStatus #statusInfoCurrencyText").html(texts.TicketWinCurrencyBet);
                $("#ticketStatus #statusDepositText").html(texts.StatusBet);
                $("#ticketStatus #statusBetDateText").html(texts.StatusBetDate);
                $("#ticketStatus #statusExpirationDateText").html(texts.StatusExpiration);
                $("#ticketStatus h1").html(texts.HeaderTicket);
                $("#ticketStatus .status-buttons .ticket-print .ui-btn-text").html(texts.StatusTicketPrint);
                $("#ticketStatus .status-buttons .credit-to-balance .ui-btn-text").html(texts.StatusTransferCredit);
                $("#ticketStatus .status-buttons .credit-to-online .ui-btn-text").html(texts.StatusTransferOnline);
                $("#ticketStatus .status-buttons .credit-cash-back .ui-btn-text").html(texts.StatusTicketCashBack);
                $("#ticketStatus .status-buttons .ticket-repeat .ui-btn-text").html(texts.StatusTicketRepeat);
                $("#ticketStatus .status-buttons .ticket-storno .ui-btn-text").html(texts.StatusTicketStorno);
                $("#ticketStatus .status-buttons .ticket-redeem-confirm .ui-btn-text").html(texts.StatusTicketRedeemPrice);
                $("#ticketStatus .status-buttons .ticket-redeem-before-confirm .ui-btn-text").html(texts.StatusTicketRedeemPrice);
                $("#ticketStatus .status-buttons .ticket-auto-redeem-settings .ui-btn-text").html(texts.StatusAutoRedeem);
                $("#ticketStatus .status-buttons .ticket-auto-redeem-set").html(texts.StatusAutoRedeemSet);
                $("#ticketStatus .status-buttons .ticket-auto-redeem-stop").html(texts.StatusAutoRedeemCancel);
                $("#ticketStatus .status-buttons .submit-ticket .ui-btn-text").html(texts.HeaderBet);
                $("#ticketStatus .status-buttons .ticket-edit .ui-btn-text").html(texts.StatusTicketEdit);
                $("#ticketStatus .status-buttons #buyBackWarning").html(texts.StatusTicketRedeemVerifiedWarning);
                // Preklady pre kontrolu tiketu - table header oddov - order tlacitka
                $("#ticketStatus #ticketOddsOrderSwitch").trigger("create");
                $("#ticketStatus #ticketOddsOrderByLabel").html(texts.StatusTicketOrderLabel);
                $("#ticketStatus #ticketOddsOrderSwitch #originalOrderSwitch .ui-btn-text").html(texts.StatusTicketAddOrder);
                $("#ticketStatus #ticketOddsOrderSwitch #parsedDateSwitch .ui-btn-text").html(texts.StatusTicketDateOrder);
                // Preklady pre kontrolu tiketu - table header oddov
                $("#ticketStatus #oddHeaderDate").html(texts.OddDate);
                $("#ticketStatus #oddHeaderBet").html(texts.OddTip);
                $("#ticketStatus #oddHeaderRate").html(texts.OddRate);
                $("#ticketStatus #oddHeaderStake").html(texts.OddStake);
                $("#ticketStatus #oddHeaderResult").html(texts.OddResult);
                $("#ticketStatus #oddHeaderState").html(texts.OddState);
                // Preklady pre kontrolu tiketu - table header kombinacii
                $("#ticketStatus #combiHeaderGroup").html(texts.Group);
                $("#ticketStatus #combiHeaderBet").html(texts.CombiPanelBetCombination);
                $("#ticketStatus #combiHeaderRate").html(texts.CombiPanelRate);
                $("#ticketStatus #combiHeaderWin").html(texts.CombiPanelWin);
                // Preklady pre kontrolu tiketu - table header historie editacii
                $("#ticketStatus #editHeaderDate").html(texts.StatusTicketTimeVersion);
                $("#ticketStatus #editHeaderRate").html(texts.StatusTicketEditRate);
                $("#ticketStatus #editHeaderWin").html(texts.StatusTicketEditEvWin);
    
                // Preklady pre freebet
                $("#freebetInfo #FbAmount .ui-block-a").html(texts.FbAmount);
                $("#freebetInfo #FbMinOdds .ui-block-a").html(texts.FbMinOdds);
                $("#freebetInfo #FbMinRateOdd .ui-block-a").html(texts.FbMinRateOdd);
                $("#freebetInfo #FbMaxRateOdd .ui-block-a").html(texts.FbMaxRateOdd);
                $("#freebetInfo #FbMinRateAll .ui-block-a").html(texts.FbMinRateAll);
                $("#freebetInfo #FbMaxRateAll .ui-block-a").html(texts.FbMaxRateAll);
                $("#freebetInfo #FbPrematchRequired .ui-block-a").html(texts.FbPrematchRequired);
                $("#freebetInfo #FbLiveRequired .ui-block-a").html(texts.FbLiveRequired);
                $("#freebetInfo #FbCreated .ui-block-a").html(texts.FbCreated);
                $("#freebetInfo #FbValidTo .ui-block-a").html(texts.FbValidTo);
    
                // Preklady pre bonifikaciu
                $("#bonificationInfo #BonMinOdds .ui-block-a").html(texts.BonMinOdds);
                $("#bonificationInfo #BonMinRateAll .ui-block-a").html(texts.BonMinRateAll);
                $("#bonificationInfo #BonPointsRequired .ui-block-a").html(texts.BonPointsRequired);
                $("#bonificationInfo #BonWinCurrencyRequired .ui-block-a").html(texts.BonWinCurrencyRequired);
                $("#bonificationInfo #BonMinBet .ui-block-a").html(texts.BonMinBet);
    
                // Preklady pre akceptovane zmeny kurzu
                $("#rateChangesButtons #acceptRateUpLabel .ui-btn-text").html(texts.RateChangeAcceptUp);
                $("#rateChangesButtons #acceptRateAllLabel .ui-btn-text").html(texts.RateChangeAcceptAll);
                $("#rateChangesButtons #acceptRateNoneLabel .ui-btn-text").html(texts.RateChangeAcceptNone);
                $("#rateChangesButtons [type=radio]").checkboxradio();
                $("#rateChangesButtons").find(".ui-radio-on").removeClass('ui-radio-on');
                $("#rateChangesButtons").find("#acceptRate" + stored.AllowedRateChange + "Label").addClass("ui-radio-on");
    
                // Preklady pre obsluhu kombinovaneho tiketu
                $("#markTopMatch .ui-btn-text").html(texts.CombiOptionsBanker);
                $("#createGroup .ui-btn-text").html(texts.CombiOptionsCreateGroup);
                $("#removeGroup .ui-btn-text").html(texts.CombiOptionsRemoveGroup);
                $("#footer-sidebar #combinationListBtn .ui-btn-text").html(texts.CombiOptionsShowCombinations);
    
                // Preklady pre obsluhu tiketu
                if (texts.TicketErr12 && !Array.isArray(texts.TicketErr12)) (texts.TicketErr12 = texts.TicketErr12.split(". "))[0] += ".";
                if (texts.OverallBetChanged && !Array.isArray(texts.OverallBetChanged)) texts.OverallBetChanged = texts.OverallBetChanged.split("{}");
    
                // Potvrdenie vymazania tiketu
                // fixujem zle zobrazenie tlacitok pre poradie krokov: navolim zapasy na ticket -> prejdem do tiketu -> kliknem na vymazat tiket -> nevymazem -> prihlasim sa -> kliknem na vymazat tiket.
                // Dovod je ze set labels sa spravi raz pred parsovanim html a aj po prihlaseni, ked by to vymazalo obsah tlacidla potrebny pre spravne zobrazenie
                $("#ticketClear #ticketClearConfirm .ui-btn-text").length ? $("#ticketClear #ticketClearConfirm .ui-btn-text").text(texts.TicketClear) : $("#ticketClear #ticketClearConfirm").html(texts.TicketClear);
                $("#ticketClear #ticketClearCancel .ui-btn-text").length ? $("#ticketClear #ticketClearCancel .ui-btn-text").text(texts.TicketCancel) : $("#ticketClear #ticketClearCancel").html(texts.TicketCancel);
                // Schvalovanie tiketu
                $("#ticketApprove a").html(texts.TicketApproveCancel);
                $("#ticketApprove h3").html(texts.TicketApproveT);
                $("#ticketApprove #approveText").html(texts.TicketApprove);
    
                // Preklady pre panel kombinacii
                $("#combinationList .head .cell:nth-child(2)").html(texts.CombiPanelRate);
                $("#combinationList .head .cell:nth-child(3)").html(texts.CombiPanelWin);
                $("#combinationList #ticketLabel").html(texts.CombiPanelBetOn);
                $("#combiNonPartial").html(texts.CombiPanelGroup);
                $("#combiPartial").html(texts.CombiPanelCombinations);
                $("#combiOriginalBet").html(texts.CombiPanelOriginalBets);
    
                // Pokial su povolene moje tikety a existuje zoznam skupin v mojich tiketoch
                if (profile.FlatCSS && profile.MyTickets.length) {
                    $("#myTicketsContainer #myTicketsLabel").html(texts.MyTicketsLabel);
                    $("#myTicketsContainer #myTicketsFilterCollapsible").collapsible();
                    // Vykresli vsetky skupiny mojich tiketov
                    var collapsibleFilter = $("#myTicketsContainer").find(".ui-collapsible-content").empty();
                
                    profile.MyTickets.forEach(function(ticketText) {
                        collapsibleFilter.append("<div id='myTickets"
                        + ticketText + "' class='my-tickets-button' onclick=player.playerTickets.myTicketsFilter('"
                        + ticketText + "')>"
                        + texts['MyTickets' + ticketText] + "</div>");
                    });
                    $("#myTickets" + stored.myTicketsActiveGroup).addClass('selected');
                    // Nastavi nazov filtra
                    $("#myTicketsFilterLabel .ui-btn-text").text(texts['MyTickets' + stored.myTicketsActiveGroup]);
                }
    
                // Preklady pre sutaz
                $("#ticketCompetition a.left").html(texts.CompetitionYes);
                $("#ticketCompetition a.right").html(texts.CompetitionNo);
    
                // Preklady pre player nastavania
                if (profile.UserSettingsSections.length) {
                    if (profile.AvailableLanguages?.length) {
                        // Menu a kostra
                        $("#userSettingsModal .menu").html(texts.UserSettingsMenu);
                        $("#userSettingsModal .my-account").html(texts.UserSettingsMyAccount);
                        $("#userSettingsModal .menu-close").html("<i></i><label>" + texts.MoreClose + "</label>");
                        $("#userSettingsModal .settings").html("<i></i>" + texts.UserSettingsMenuSettings);
                        $("#userSettingsModal .my-data").html("<i></i>" + texts.UserSettingsMenuMyData);
                        // Lokalizacia
                        $("#userSettingsModal #localisation").html(texts.UserSettingsLocalisation);
                        $("#userSettingsModal #language").html(texts.UserSettingsLanguage);
                        // Oblubene
                        $("#userSettingsModal #favorite").html(texts.UserSettingsFavorite);
                        $("#userSettingsModal #favoriteSportLeagueLabel").html(texts.UserSettingsLeagueSports);
                        $("#userSettingsModal #favoriteEventLabel").html(texts.UserSettingsFavoriteEvents);
                        // Povolenie zmien kurzu
                        $("#selectRateChange #selectedRateChange").text(texts["RateChangeAccept" + stored.AllowedRateChange]);
                        // Dostupne jazyky v select box
                        if ($("#userSettingsLanguageList .select-group").is(":empty")) {
                            var userSelectButtonLangs = "";
                            profile.AvailableLanguages.forEach(function(langAvailable) {
                                userSelectButtonLangs += "<div class='select-item " + (lang === langAvailable? "selected": "") + "' onmousedown='player.playerSettingsModule.modifyUserSettingsObject(\"playerLanguage\", \""
                                + langAvailable.code + "\")'><span class='lang-img lang-"
                                + langAvailable.code + "'></span>"
                                + langAvailable.languageName + "</div>";
                            });
                            $("#userSettingsLanguageList .select-group").append(userSelectButtonLangs);
                        }
                    }
    
                    if (profile.UserSettingsSections.includes("ticket")) {
                        $("#userSettingsModal #ticket").html(texts.HeaderTicket);
                        $("#userSettingsModal #rateChange").html(texts.RateChangeShow);
    
                        var selectGroupRateChange = $("#userSettingsRateChangeList .select-group").empty();
                        ["Up", "All", "None"].forEach(function(rateChangeType) {
                            selectGroupRateChange.append(
                                "<div class='select-item " + (stored.AllowedRateChange === rateChangeType? "selected": "") + "' onmousedown='player.playerSettingsModule.modifyUserSettingsObject(\"allowedRateChangePlayer\", \""
                                + rateChangeType + "\")' id='rateChangeItem"
                                + rateChangeType + "'>"
                                + texts["RateChangeAccept" + rateChangeType] + "</div>"
                            );
                        });
                    }
                    if (profile.BiometryLogin && profile.UserSettingsSections.includes("myData")) {
                        $("#userSettingsModal #myDataCardNumberLabel").html(texts.MyDataCardNumberLabel);
                        $("#userSettingsModal #myDataPinLabel").html(texts.MyDataPinLabel);
                        $("#userSettingsContent #myDataPin").attr("my-data-pin-hidden", "****");
                        $("#userSettingsContent #myDataCard").attr("my-data-card-hidden", "**********");
                        // Tlacidlo zobrazenia PIN kodu
                        $("#userSettingsModal .user-data-pin__button")
                            .html("<i></i>")
                            .attr("my-data-pin-hidden", texts.MyDataPinShow)
                            .attr("my-data-pin", texts.MyDataPinHide);
                    } else {
                        $("#userSettingsModal #userSettingsMyData").hide();
                    }
                    // Notifikacie
                    $("#userSettingsModal #notify").html(texts.UserSettingsNotify);
                    $("#userSettingsModal #notifySMSLabel").html(texts.UserSettingsNotifySMS);
                    // Tlacidlo ulozenia
                    $("#userSettingsModal #saveUserSettings").html(texts.UserSettingsSave);
                    // Oznacenie prvej polozky v menu
                    // Nie cez mousedown trigger ktory zavola userAction (ktory spusta signalR)
                    player.userSettingsMenuSwitch('settings');
                }
                $("#playerBonusesModal .player-bonuses-label").html(texts.UserSettingsMyAccount);
    
                // Preklady pre hracske bonusy
                if (profile.Bonuses) {
                    // Button v tikete
                    $("#ticket #bonusesButton .button-label").html(texts.ContentBonusTitle);
                    // Menu Bonusov
                    $("#bonusesMenu .menu").html(texts.MenuBonusesTitle);
                    // Content Bonusov
                    $("#bonusesContent .player-bonuses-label").html(texts.ContentBonusTitle);
                    // Promokod
                    $("#bonusesContent #bonusesContentPromocode0 .label").html(texts.PlayerBonusesLabel);
                    $("#bonusesContent #bonusesContentPromocode0 #promocodeInfoButton").html(texts.PlayerBonusesInfoButton);
                    $("#bonusesContent #bonusesContentPromocode0 #promocodeLabel").html(texts.PromocodeLabel);
                    $("#bonusesContent #bonusesContentPromocode0 #promocodeConfirmButton").html(texts.PlayerBonusesConfirmButton);
                    $("#bonusesContent #bonusesContentPromocode0 .notice").html(texts.PlayerBonusesNotice);
                    // Volne stavky
                    $("#bonusesContent #bonusesContentPromocode1 #freebets").html(texts.PlayerBonusesFreebets);
                    var selectGroupFreebets = $("#bonusesContent #bonusesContentPromocode1 .select-group").empty();
                    stored.BonusesFreebetsStatus = 0;
                    [texts.BonusFreebetState0, texts.BonusFreebetState1, texts.BonusFreebetState2, texts.BonusFreebetState3, texts.BonusFreebetState4, texts.BonusFreebetState5].forEach(function(freebetType, f) {
                        selectGroupFreebets.append(
                            "<div class='select-item " + (texts["BonusFreebetState" + stored.BonusesFreebetsStatus] === freebetType? "selected": "") + "' onmousedown='player.playerBonusModule.modifyFreebetsBonusesFilter(\""
                            + f + "\")' id='bonusFreebetItem"
                            + f + "'>"
                            + freebetType + "</div>"
                        );
                    });
    
                    // Aktivacny bonus
                    $("#bonusesContentActivatingBonus #activatingBonus").html(texts.BonusActivatingLabel);
                    $("#bonusesContentActivatingBonus #activatingBonusLabel").html(texts.BonusActivatingSubLabel);
                }
    
                // Preklady pre quickbety
                if (profile.QuickBetsAllowed) {
                    // Obsah okna s quickbetmi
                    $("#quickBetWrapper #quickBetRulesRules").html(texts.QuickBetRulesLabel.toUpperCase());
                    $("#quickBetWrapper #quickbetRulesActualisation").html(texts.QuickBetRulesActualsation + " " + stored.Allowance.quickbetRules.date);
                    $("#quickBetWrapper #quickBetRulesContent").html(texts.QuickBetRulesContent);
                    // Buttony quickbetov
                    $(".quick-bet .info-text").html(texts.QuickBetButtonLabel);
                    $(".quick-bet .badge").html(texts.QuickBetButtonNewLabel);
                    // QuickBet Prepínač - výhry pripisovať k zostatku
                    $("#quickBetBalanceAutoAdd .label").html(texts.QuickBetSwitchBalanceAutoAdd);
                }
    
                if (profile.IsLoginRequired && !Array.isArray(texts.ModalVlcUnverifiedQrInfo)) {
                    texts.ModalVlcUnverifiedQrInfo = texts.ModalVlcUnverifiedQrInfo.split("{}");
                    texts.ModalVlcUnlockingInfo = texts.ModalVlcUnlockingInfo.split("{}");
                    texts.ModalVlcBlockedQrInfo = texts.ModalVlcBlockedQrInfo.split("{}");
                    texts.ModalVlcOptions3Text = texts.ModalVlcOptions3Text.split("{}");
                }
    
                // Preklady pre ponuku viac
                $("#more h3").html(texts.MoreExtendedOffer);
                $("#more .menu-bonuses").html("<i></i>" + texts.MoreBonuses);
                $("#more .menu-terms").html("<i></i>" + texts.MoreTerms);
                $("#more .menu-gdpr").html("<i></i>" + texts.MoreGDPR);
                $("#more .menu-lang").html("<i><span>" + offer.lang + "</span></i>" + texts.MoreLanguage);
                $("#more .menu-ticket").html("<i></i>" + texts.MoreManualTicket);
                // Zobrazenie moznosti zadania kodu vernostnej karty v menu (manualne prihlasnie hraca pomocou karty)
                if (profile.ClubLoyaltyCard) {
                    $("#more .menu-club").html("<i></i>" + texts.MoreClubStatic);
                    if (!profile.IsBiometricLoginOnly) {
                        // Ked je na SB moznost len biometrickeho prihlasenia, nezobrazujeme v menu "Prihlasit se pomocou karty"
                        $("#more a.menu-loyalty-card").html("<i></i>" + texts.MoreManualLoyaltyCard);
                        $("#more a.menu-loyalty-card").show();
                    }
                }
    
                $("#more .menu-service").html("<i></i>" + texts.MoreService);
                $("#more .menu-close").html("<i></i><label>" + texts.MoreClose + "</label>");
                $("#more #version span").eq(0).html(texts.MoreDoxxbetIS);
                $("#more #attention").html(texts.Attention);
    
                if (stored.hasClubHelper) {
                    setTimeout(function() {
                    // Zobrazenie sekcii "Ako to funguje" a "Vernostna karta"
                        $("#ticketHelp").addClass("has-club");
                        $("#ticketHelp #howItWorks").empty().append('<h1 id="howItWorksLabel">'
                        + texts.TicketHelpT + '</h1><div class="help-step"><div class="ui-icon-main tip-ico"><span>'
                            + 1 + '</span></div><div class="help-text">' + texts.TicketHelpHasClub1 + '</div></div>');
                        $("#ticketHelp #howItWorks").append('<div class="help-step"><div class="ui-icon-main tip-ico"><span>'
                            + 2 + '</span></div><div class="help-text">' + texts.TicketHelpHasClub2 + '</div></div>');
                        $("#ticketHelp #howItWorks").append('<div class="help-step"><div class="ui-icon-main tip-ico"><span>'
                            + 3 + '</span></div><div class="help-text">' + texts.TicketHelpHasClub3 + '</div></div></div>');
    
                        $("#ticketHelp #helpClubCard #clubCardLabel").html(texts.TicketHelpClubCardT);
                        $("#ticketHelp #helpClubCard #clubHelp").html('<li>' + texts.TicketHelpCardAdvantage1 + '</li><li>'+ texts.TicketHelpCardAdvantage2 + '</li>');
                        $("#ticketHelp #helpClubCard #claims .claim-label").html(texts.TicketHelpCardClaimsT);
                        $("#ticketHelp #helpClubCard #clubClaimList").html('<li><div class="list-icon icon-compensation"></div><div class="list-item-text">'
                            + texts.TicketHelpCardClaim1 + '</div></li>'
                            + '<li><div class="list-icon icon-golden-league"></div><div class="list-item-text">'
                            + texts.TicketHelpCardClaim2 + '</div></li>'
                            + '<li><div class="list-icon icon-history-light"></div><div class="list-item-text">'
                            + texts.TicketHelpCardClaim3 + '</div></li>'
                            + '<li><div class="list-icon icon-gift"></div><div class="list-item-text">'
                            + texts.TicketHelpCardClaim4 + '</div></li>');
                        $("#ticketHelp #helpClubCard .note").html(texts.TicketHelpCardDemand);
                        $("#ticketHelp .help-button .text").html(texts.TicketHelpButtonLabel);
                        $("#ticketHelp #cardImage").addClass(offer.country + " " + offer.lang);
                    }, 4000);
                } else {
                    // Zobrazenie sekcie "Ako to funguje"
                    $("#ticketHelp #howItWorks").html("<h1>" + texts.TicketHelpT + "</h1>");
                    $("#ticketHelp #howItWorks").append('<div class="help-step"><div class="ui-icon-main tip-ico"><span>'
                        + 1 + '</span></div><div class="help-text">' + texts.TicketHelp1 + '</div></div>');
                    $("#ticketHelp #howItWorks").append('<div class="help-step"><div class="ui-icon-main tip-ico"><span>'
                        + 2 + '</span></div><div class="help-text">' + texts.TicketHelp2 + '</div></div>');
                    $("#ticketHelp #howItWorks").append('<div class="help-step"><div class="ui-icon-main tip-ico"><span>'
                        + 3 + '</span></div><div class="help-text">' + texts.TicketHelp3 + '</div></div>');
                }
    
                // Preklady pre home obrazovku a footer
                $("#homeButtons .ui-block-a .home-button div").html(texts.FooterLabelLive);
                $("#homeButtons .ui-block-b .home-button div").html(texts.FooterLabelStartingMatches);
                $("#homeButtons .ui-block-c .home-button div").html(texts.FooterLabelToday);
                if (profile.VirtualGames) {
                    $("#homeButtons .ui-block-d .home-button div").html(texts.FooterLabelVirtualGames);
                } else {
                    $("#homeButtons .ui-block-d .home-button div").html(texts.FooterLabelOtherDates);
                }
    
                $("#popularLeaguesTopTips #topTipsButton .ui-btn-text").html(texts.TopTipsHeader);
                $("#popularLeaguesTopTips #popularLeaguesButton .ui-btn-text").html(texts.PopularLeaguesHeader);
    
                // Preklady pre Event Detail a Statistiky v event detaile
                $("#event #topButtons #rates").html(texts.EventHeaderRates);
                $("#event #topButtons #statsLabel").html(texts.EventHeaderStats);
    
                $("#event #statsBar #h2hButton a").html(texts.StatsH2HLabel);
                $("#event #statsBar #leagueButton a").html(texts.OfferTableLabel);
                $("#event #statsBar #playerButton a").html(texts.StatsPlayerLabel);
    
                // Footer
                var fooLabel;
                for (i = 1; i <= $("#footer .footer__nav-item").length; i++) {
                    switch (i) {
                        case 1:
                            fooLabel = "FooterLabelHome";
                            break;
                        case 2:
                            fooLabel = "FooterLabelOffer";
                            break;
                        case 3:
                            fooLabel = "FooterLabelLive";
                            break;
                        case 4:
                            fooLabel = "FooterLabelStartingMatches";
                            break;
                        case 5:
                            fooLabel = "FooterLabelToday";
                            break;
                        case 6:
                            fooLabel = "FooterLabelOtherDates";
                            break;
                        case 7:
                            if (profile.Results) {
                                fooLabel = "FooterLabelResults";
                            } else if (profile.LotteryAllowed) {
                                fooLabel = "FooterLabelLotteryGames";
                            } else {
                                $("#footer #f" + i).hide();
                            }
                            break;
                        case 8:
                            if (profile.VirtualGames) {
                                fooLabel = "FooterLabelVirtualGames";
                            } else {
                                fooLabel = "FooterLabelPopular";
                            }
                            break;
                    }

                    // pridanie class do tlacidla pre styling podla tlacidla
                    $("#footer #f" + i + ".footer__nav-item").addClass("footer__nav-item--" + fooLabel.replace("FooterLabel", "").toLowerCase());
                    /* 
                        footer__nav-item--home
                        footer__nav-item--offer
                        footer__nav-item--live
                        footer__nav-item--startingmatches
                        footer__nav-item--today
                        footer__nav-item--otherdates
                        footer__nav-item--results
                        footer__nav-item--lotterygames
                        footer__nav-item--virtualgames
                        footer__nav-item--popular
                    */

                    // nastavenie textu tlacidla
                    $("#footer #f" + i + " .footer__nav-item-text").html(texts[fooLabel]);
                }
    
                // Nova virtualna hra (button 7)
                if (profile.VirtualGames && profile.NewVirtualGameIDs && profile.NewVirtualGameIDs.length)
                    $("#footer #f8 .ui-btn-inner").prepend('<span class="footer-new new-game-' + offer.lang + '"></span>');
    
                //  ObligatoryInfo in the Footer
                if (profile.ShowObligatoryInfo) {
                    $("#footer #obligatoryInfo").html(`<i class='icon-18plus'><i class='path1'></i><i class='path2'></i></i><span>${texts.FooterObligatory18plus} </span><span></span>${texts.FooterObligatoryInfo}</span>`);
                }
    
                // Doplni informaciu o minimalnej vyske stavky
                if (stored.MinDeposit) $("#ticketHelp .help-step .help-text").eq(0).append(" " + texts.Tc_ERR_MINBET + " " + shared.floor2(stored.MinDeposit, 1) + profile.Currency + ".");
    
                // preklady pre infomodal o ukonceni otvaracej doby
                // sekundy [0|1|2-4|5]
    
                if (typeof texts.ModalClosingTime_seconds === 'string') {
                    texts.ModalClosingTime_seconds = texts.ModalClosingTime_seconds.split('{}');
                }
    
                // minuty [0|1|2-4|5]
                if (typeof texts.ModalClosingTime_minutes === 'string') {
                    texts.ModalClosingTime_minutes = texts.ModalClosingTime_minutes.split('{}');
                }
    
                // Ostatne
                $("#event #showAllChances a").html(texts.OfferGroupAll);
    
                if (profile.pageActualisationInfo && profile.pageActualisationInfo.length) {
                    $("#events #pageActualisationInfo").html(texts.OfferActualisationInfo);
                }
    
                // preklady pre infomodal o automatickom odhlaseni 
                if (profile.ClubLoyaltyCard && typeof texts.ModalAutoLogOffPlayer_seconds === 'string') {
                    texts.ModalAutoLogOffPlayer_seconds = texts.ModalAutoLogOffPlayer_seconds.split('{}');
                }
    
                if (lang)
                    more.menu.setBonuses(profile.Bonuses);
                    more.menu.setClub(profile.Club, profile.ClubHomeButton, profile.ClubNew, profile.ClubCompetition);
                    more.menu.setTerms(profile.Terms);
                    more.menu.setGDPR(profile.GDPR);
                // more.menu.setProperties(profile.Terms, profile.GDPR, profile.Club, profile.ClubHomeButton, profile.ClubNew, profile.ClubCompetition);
                // nastavenie jazyka pre trackovanie jazyka sb pre usera do GA
                gtag('set', 'language', (lang || offer.lang));
                return true;
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
    },

    // Funkcia na stopnutie vsetkych refresh
    stopAllRfs: function(submitting) {
            if (!submitting) main.closeDialog(); // -> closeEvent();
            ticket.stopTicketRfs();
            ticket.stopTicketApprove();
    },

    // Funkcia, ktora zamkne submit tlacitka
    lockSbmButtons: function(startSubmitting) {
            try {
                $("#sportBox .content-ticket, #ticketHeader, #submitTicket, #ticket #removeOdd, #ticketStatus .status-buttons .submit-ticket, #rateChangesButtons label").addClass("lock-btn");
                if (startSubmitting) {
                    $("#submitTicket, #ticketStatus .status-buttons .submit-ticket").addClass("submitting");
                }
                return true;
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
    },

    // Funkcia, ktora odomkne submit tlacitka
    unlockSbmButtons: function(stopSubmitting) {
            try {
                if (stopSubmitting) {
                    $("#submitTicket, #ticketStatus .status-buttons .submit-ticket").removeClass("submitting");
                    list.Sync = 0;
                }
                // Spristupni tiket, tlacitko Submit ticket a Clear ticket - ak uz dobehli vsetky add odds
                if (!list.Sync) $("#sportBox .content-ticket, #ticketHeader, #submitTicket, #ticket #removeOdd, #ticketStatus .status-buttons .submit-ticket, #rateChangesButtons label").removeClass("lock-btn");
                return true;
    
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                $("#submitTicket").removeClass("submitting");
                $("#sportBox .content-ticket, #ticketHeader, #submitTicket, #ticket #removeOdd, #ticketStatus .status-buttons .submit-ticket").removeClass("lock-btn");
                return false;
            }
    },

    // Tlactiko na spustenie rezimu manualneho zadavania cisla vernostnej karty
    loyaltyManual: function() {
            if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu
            main.closeDialog();
            setTimeout(function () {
                try {
                    LoyaltyManualInput();
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    return false;
                }
            }, 500);
    },

    // Prechod na stranku s ponukou jazykovych prekladov
    openPage: function(subPage, subPageMenu, callback) {
            try {
                // tato funkcia so pouziva na otvorenie (club, bonusov, gdpr, terms, language) aj z ponuky viac a aj z nastaveni usera, preto je tu parameter subPageMenu ktory sa pouziva v pripade otvorenia bonusov z ponuky viac pre otvorenie konkretnej sekcie bonusov
                dialog.close();
                switch (subPage) {
                    case "bonuses":
                        if (typeof subPageMenu !== 'undefined') {
                            stored.bonusIndexToOpen = subPageMenu;
                        }
                        $("body").off("mousedown");
                        dialog.open({
                            id: "bonuses", 
                            url: url.base + "more/bonus_" + profile.Properties.Bonuses + ".html",
                            parseJQM: false,
                            onOpen: function() { modal.showLoading(); }, // pre pomalsie nacitanie
                            shown: function() { modal.hideLoading(); },
                            onError: function() { modal.hideLoading(); }
                        });
                        break;
                    case "club":
                        $("body").off("mousedown");
                        dialog.open({
                            id: "doxxbetClub", 
                            url: url.base + "more/" + offer.country + "/club/club_" + profile.Properties.Club + ".html",
                            parseJQM: false,
                            onOpen: function() { modal.showLoading(); }, // pre pomalsie nacitanie
                            shown: function() {
                                modal.hideLoading();
                                if (callback) {
                                    callback();
                                }
                            },
                            onError: function() { modal.hideLoading(); }
                        });
                        break;
                    case "terms":
                        $("body").off("mousedown");
                        dialog.open({
                            id: "doxxbetTerms",
                            url: url.base + "more/" + offer.country + "/terms/terms_" + profile.Properties.Terms + ".html",
                            parseJQM: false,
                            onOpen: function() { modal.showLoading(); }, // pre pomalsie nacitanie
                            shown: function() { modal.hideLoading(); },
                            onError: function() { modal.hideLoading(); }
                        });
                        break;
                    case "gdpr":
                        $("body").off("mousedown");
                        dialog.open({
                            id: "doxxbetTerms",
                            cssClass: "doxxbet-gdpr",
                            url: url.base + "more/" + offer.country + "/gdpr/gdpr_" + profile.Properties.GDPR + ".html",
                            parseJQM: false,
                            onOpen: function() { modal.showLoading(); }, // pre pomalsie nacitanie
                            shown: function() { modal.hideLoading(); },
                            onError: function() { modal.hideLoading(); }
                        });
                        break;
                    case "language":
                        dialog.open({
                            id: "modalLanguage",
                            parseJQM: false,
                            persistent: true
                        });
                    default:
                        // Prechod na ponuku lebo subPage neexistuje
                        $.mobile.changePage("#sportBox", {"role": "page"});
                        setTimeout(function () {
                            // TODO - treba toto ešte?
                            $.mobile.changePage("#" + subPage, {"role": "dialog"});
                        }, 100);
                        return false; // pouzivame pri odpovedi pre native app
                }
    
                return true;
            } catch (e) {
                dialog.close();
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                main.startApp(1);
                return false;
            }
    },

    // Otvranie dialogovy okien s moznostou zatvorenia kliknutim mimo okno
    dialogOpen: function(part) {
            try {
                if (more.asideLoading.inProgress) return false; // Kontrola ci nie je spustene nejake schvalovanie tiketu
                var dialogWindow;
                switch (part) {
                    case "more":
                        communication.topScreenClose();
                        dialog.open({
                            id: "more",
                            persistent: true,
                            parseJQM: false
                        });
                        dialogWindow = "#more .ui-dialog-contain";
                        break;
                    case "language":
                        main.openPage('language');
                        dialogWindow = "#modalLanguage .ui-dialog-contain";
                        break;
                    case "ticketDelete":
                        dialogWindow = "#ticketClear .ui-dialog-contain";
                        dialog.open({
                            id: "ticketClear",
                            backdropDismiss: false,
                            parseJQM: true,
                            persistent: true
                        });
                        break;
                    case "ticketStatusTicketCode":
                    case "ticketStatus":
                        dialogWindow = "#ticketStatus .ui-content";
                        break;
                    case "event":
                        dialogWindow = "#event .ui-content";
                        break;
                    case "quickBet":
                        dialogWindow = "#quickBetWrapper .ui-content";
                        break;
                    case "searchDial":
                        dialog.open({
                            id: 'searchDial',
                            modal: false,
                            fullScreen: false,
                            clickOutsideDismiss: true,
                            persistent: true,
                            parseJQM: true,
                            jsEval: false,
                            cssClass: "calc-theme",
                            onOpen: function() { $("#searchDialEvent").addClass("ui-disabled"); },
                            onClose: function() { more.search.clearManualDialDisplay(); }
                        });
                        dialogWindow = "#searchDial";
                        break;
                    case "playerBonusesModal":
                        dialogWindow = "#playerBonusesModal";
                        dialog.open({
                            id: "playerBonusesModal",
                            persistent: true,
                            parseJQM: false,
                            backdropDismiss: false,
                            onClose: function() { $("#playerBonusesModal #promocodeInput").val(''); } // Vymazanie hodnoty z inputu promokodu pri zatvarani modalu lebo inak by tam ostaval aj pri opatovnom otvoreni
                        });
                        break;
                    case "userSettingsModal":
                        dialog.open({
                            id: "userSettingsModal",
                            persistent: true,
                            parseJQM: false,
                            // nastavenie defaultne zobrazenia menu na "Nastavenia"
                            onOpen: function() { player.userSettingsMenuSwitch('settings'); } 
                        });
                        break;
                }
                if (dialogWindow) {
                    $("body").on("mousedown", function (event) {
                        // Jedna sa o zatvorenie informacneho okna v detaile tiketu, ktore nezatvara cely detail tiketu
                        if ((event.srcElement?.id !== "hideInfoButton") && !($(event.srcElement).parents("#ticketStatus"))) {
                            main.closeDialog();
                        }
                    });
                }
                return true;
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
    },

    // TODO - toto by sme pri dialogovych oknach cez dialogmanager nemali potrebovat
    // Osetrenie vypnutia body handlera (pri kliknuti mimo dialogove okno)
    healBodyMouseDown: function() {
            try {
                $("body").on("mousedown", function (event) {
                    if (window.location.hash == "") {
                        $("body").off("mousedown");
                    }
                });
                return true;
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
    },

    // Zatvorenie dialogoveho okna
    closeDialog: function(notPreserve) {
            // GA4 - trackovanie konca sledovania matchtracker, ten inak neposiela koniec sledovania z hornej
            if (stored?.topScreenActive == "matchTracker") communication.dataTrackModule.track.video_end("matchTracker", {"screenShow": false});
            try {
                if (offer.eventID || $('#event').hasClass('league-table')) {
                    // Detail zapasu alebo ligove tabulky otvaratelne z plachty
                    eventDetail.closeEvent();
                } else if (dialog.isOpen("ticketApprove")) {
                    if (stored.OverallTotalBet) {
                        ticket.calc("clear");
                    }
                    $(".ui-loader").removeClass("large");
                } else if (dialog.isOpen("universalModalDialog") || stored.FreebetModalActive || stored.JackpotModalActive) {
                    // Univerzalne modalne okno pre zobrazenie freebetu, vlc, biometrie a jackpotu
                    clearTimeout(rfs.vlcContentTimeout);
                    delete rfs.vlcContentTimeout;
                    stored.FreebetModalActive = false;
                    stored.JackpotModalActive = false;
                    if (!Object.keys(rfs.jackpotModal).length) {
                        // Zamedzenie otvorenia sekcie ak sa ma zobrazit jackpot modalne okno
                        main.unlockSbmButtons();
                    }
                } else if (dialog.isOpen("userSettingsModal")) {
                    // Ak sa jedna o okno uzivatelskych nastaveni
                    if (notPreserve && stored.UserSettings && stored.UserSettings.Original && stored.UserSettings.Modified) {
                        if (stored.UserSettings.Original.playerLanguage !== stored.UserSettings.Modified.playerLanguage) {
                            // Prihlaseny player s neulozenymi zmenami, vrati povodne nastavenia
                            player.playerSettingsModule.modifyUserSettingsObject("playerLanguage", stored.UserSettings.Original.playerLanguage, "user");
                        }
                        if (stored.UserSettings.Original.allowedRateChangePlayer !== stored.UserSettings.Modified.allowedRateChangePlayer) {
                            // Prihlaseny player s neulozenymi zmenami, vrati povodne nastavenia
                            player.playerSettingsModule.modifyUserSettingsObject("allowedRateChangePlayer", stored.UserSettings.Original.allowedRateChangePlayer);
                        }
                    }
                    // Player zatvara okno "Moj ucet" - vycisti udaje
                    userData().hide();
                    if (profile.IsSourceOfIncome) {
                        if (Array.isArray(player.incomeSourcesModule.playerIncomeSources)) {
                            player.incomeSourcesModule.playerUnsavedIncomeSources = player.incomeSourcesModule.playerIncomeSources?.slice();
                        } else {
                            player.incomeSourcesModule.playerUnsavedIncomeSources = [];
                        }
                        player.incomeSourcesModule.incomeSourcesToUserSettings();
                    }
                } else if (dialog.isOpen("playerBonusesModal")) {
                    // Modalne okno pre prihlaseneho playera
                    $("#playerBonusesModal #bonusesList").empty();
                    $("#bonusesContent #bonusesContentPromocode, #bonusesContent .settings-content").hide();
                    $('#playerBonusesModal #freebetsTable td, #playerBonusesModal #activatingBonusesTable td').empty();
                    $("#playerBonusesModal .bonus-iframe").remove();
                    stored.callPlayerBonusCB = null;
                    stored.activeBonusName = null;
                } else if (dialog.isOpen("bonuses")) {
                    // Vymaze specialny bonus z bonus listu
                    profile.BonusList = profile.BonusList.filter(function (bItem) {
                        if (bItem.loggedClientRecordOrder !== -2) {
                            return bItem;
                        }
                    })
                } else if ($.mobile.activePage.is("#quickBetWrapper")) {
                    quickbet.closeQuickBet();
                }
    
                stored.redirectTo = "";
                $("body").off("mousedown");
                $("#event .ui-content").unbind("mousedown");
    
                // Zatvori dialogove okno
                if (!ct.closingDialog && window.location.hash != '') {
                    ct.closingDialog = true;
                    // TODO - toto este otestovat ci sa deje '#&ui-state=dialog&ui-state=dialog'
                    // TODO - toto asi moze ist prec po prerobeni dialogov na html dialog elementy
                    if (window.location.hash != "#&ui-state=dialog&ui-state=dialog") {
                        window.history.go(-1);
                    } else {
                        window.history.go(-2);
                    }
                    $.mobile.changePage("#sportBox", {"role": "page"});
                    window.location.hash = '';
                    setTimeout(function () {
                        $.mobile.changePage("#sportBox", {"role": "page"});
                        window.location.hash = '';
                        ct.closingDialog = false;
                    }, 10);
                }
    
                if (stored.tempInputGUID || stored.tempTicketCode) {
                    // Ak zisti ze sa zatvara detail zapasu ktory bol otvoreny z detailu tiket tak otvori tiket detail
                    if (stored.tempInputGUID) {
                        setTimeout(function(tempInputGUID) {
                            stored.OriginalInputGUID = tempInputGUID;
                            service.loadPure("ticketStatus");
                            stored.tempInputGUID = null;
                            main.userAction();
                            stored.redirectTo = "";
                        }, 10, stored.tempInputGUID);
                    } else if (stored.tempTicketCode) {
                        setTimeout(function(ticketCode) {
                            stored.OriginalInputCode = ticketCode;
                            service.loadPure("ticketStatusTicketCode");
                            stored.tempTicketCode = null;
                            main.userAction();
                            stored.redirectTo = "";
                        }, 10, stored.tempTicketCode);
                    }
                } else {
                    modal.hideTooltip();
                    ticketDetail.clearTicketStatus(true);
                }
                if (dialog.isOpen("doxxbetTerms") || dialog.isOpen("doxxbetClub")) {
                    // Fix - Pri reloade ponuky pocas otvoreneho klubu, gdpr, .. list zapasov nema height. Opatovne, ak treba nastavi class scroll-offer
                    setTimeout(function() {
                        shared.scrollModule.scrollButtons("table");
                    });
                }

                // po zatvoreni dialogu zavolam funkciu, ktora vola native app ak je zatvorene "gdpr" alebo "terms" okno
                // rozhodovanie riesim vo funkcii
                // momentalne sa pouziva iba pri onboardingu
                legalDocs.hidden(event?.target?.id);        
                // zatvorenie vsetkych ostatnych dialogov, ktore nie su v podmienkach vyssie a su stale otvorene
                // zatvorim vsetky dialogy okrem "errorDialog" main.closeDialog sa vola aj v modal.showErrObj
                dialog.close(dialog.getOpenDialogs().filter(function(dialogID) { return dialogID !== "errorDialog"; }));

                return true;
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                return false;
            }
    },

    // LOAD (vyrenderovanie) stranky
    buildPage: function(pageID, data, refresh, requestUrl) {
            try {
                // Rendering danej stranky
                switch (pageID) {
                    case "home":
                        home.homeRender(data);
                        if (odds?.length || stream.isStreamPlaying) {
                            // #buildPage pri render domovskej stranky potrebujeme inicializovat signalR
                            // pozor, len v pripade ked su na tikete oddy (tiket zmeny dopytujeme cez EVCT_idEVCT)
                            // checkSignalR 1. argument anonymna funkcia pre zachovanie callback refresh argumentu
                            events.eventsSignalrModule.checkSignalR(function() { events.eventsSignalrModule.setSignalR(refresh) }, events.eventsSignalrModule.initSignalR);
                        } else {
                            // Ak nie su na tikete oddy, zastavime signalR (po dohode s MForgacom)
                            // setTimeout z dovodu aby najskor stihlo dobehnut nastavenie signalR ktore sa vola pri userAction funkcii
                            setTimeout(function() {
                                // Odpoji signalR a vycisti signalR view
                                events.eventsSignalrModule.stopSignalR();
                                offer.signalrView = [];
                            }, 0);
                        }
                        break;
                    case "popularLeaguesHome":
                        home.popularLeaguesHome(data);
                        break;
                    case "popularLeagues":
                        home.popularLeaguesModule.popularLeaguesRender(data);
                        // #buildPage {popularLeagues} startPage s custom hodnotou
                        events.eventsSignalrModule.checkSignalR(function() { events.eventsSignalrModule.setSignalR(refresh) }, events.eventsSignalrModule.initSignalR);
                        break;
                    case "sportsBook":
                        player.playerFavoritesModule.favoriteStructure(data);
                        sportsbook.wholeMenuHandler(pageID, data);
                        // Dochadzalo k duplicitnemu nastavovaniu signalrView
                        // events.eventsSignalrModule.setSignalR(refresh);
                        // Ak sa jedna o ponuku v "Neskor", aleboo kliknutie v LIVE menu SPORT -> ROOT
                        if (stored.isMatchesFilterActive || (offer.page === "live" && lastSportID)) {
                            sportsbook.offerMenuSelectSport();
                            stored.redirectTo = "";
                        }
                        break;
                    case "sportsBookRegions":
                        sportsbook.wholeMenuHandler(pageID, data, offer.pointer);
                        break;
                    case "sportsBookLeagues":
                        // Klasicka liga, sportova udalost - liga, zlata liga
                        sportsbook.wholeMenuHandler(pageID, data, offer.pointer);
                        break;
                    case "sportsBookEventsFavorites":
                        // Pocitanie poctu response
                        // Identifikacia sportov a lig ktore postupne prichadzaju
                        if (data) {
                            stored.PlayerFavorite.sportLeagueCupCount--;
                            if (data.EventChanceTypes && data.EventChanceTypes[0]) {
                                var sportID = Number(data.EventChanceTypes[0].SportID);
                                var leagueID = Number(data.EventChanceTypes[0].LeagueCupID);
                                // Dodatocne skontrolovany response
                                if (stored.PlayerFavorite.sport.includes(sportID)) {
                                    // Response je cely sport
                                    if (!stored.PlayerFavorite.pFavorites[sportID]) {
                                        stored.PlayerFavorite.pFavorites[sportID].allData = new Object();
                                    }
                                    stored.PlayerFavorite.pFavorites[sportID].allData = data;
                                } else if (stored.PlayerFavorite.leagueCup.includes(leagueID)) {
                                    // Response je league
                                    if (!stored.PlayerFavorite.pFavorites[sportID].playerLeaguesData) {
                                        stored.PlayerFavorite.pFavorites[sportID].playerLeaguesData = new Object();
                                    }
                                    stored.PlayerFavorite.pFavorites[sportID].playerLeaguesData[leagueID] = data;
                                }
                            }
                        }
                        if (stored.PlayerFavorite.sportLeagueCupCount === 0) {
                            var dataMerged;
                            if (offer.pointer === "FA0") {
                                var favoriteSportsInOrder = Object.values(stored.allSports).filter(function(sport) {
                                    return Object.keys(stored.PlayerFavorite.pFavorites).includes(String(sport.ID));
                                }).sort(function(sportA, sportB) {
                                    return sportA.Order - sportB.Order;
                                }).map(function(s) {
                                    return s.ID;
                                });
                                dataMerged = player.playerFavoritesModule.composeSports(favoriteSportsInOrder);
                            } else if (offer.pointer.replace(/\d/g, '') === "FASP") {
                                dataMerged = player.playerFavoritesModule.composeSports([offer.sportID]);
                            }
                            main.buildPage("sportsBookEvents", dataMerged, false);
                            setTimeout(function() {
                                shared.scrollModule.scrollReload("sportsBookEventsFavorites", "reload");
                                service.loadPureUnlockBtn(refresh);
                                $("#sportsBook").removeClass("ui-disabled");
                            }, 1000);
                        }
                        break;
                    case "sportsBookEventsLotteryGames":
                        lottery.eventsLotteryGamesSendToIframe(data, refresh);
                        events.eventsSignalrModule.setSignalR(refresh);
                        break;
                    case "sportsBookEvents":
                        events.eventsRender(data, requestUrl);
                        // #buildPage {sportsBookEvents} startPage s custom hodnotou
                        // SignalR view sa nastavuje v pripade ponuky ak sa jedna o ponuku/ vysledky
                        events.eventsSignalrModule.checkSignalR(function() { events.eventsSignalrModule.setSignalR(refresh) }, events.eventsSignalrModule.initSignalR);
                        if (!(offer.page === "results" || stored.redirectTo === "results")) {
                            if (refresh) {
                                setTimeout(function() {
                                    shared.scrollModule.scrollReload(pageID, "reload");
                                });
                            } else {
                                shared.scrollModule.scrollPage("table", "top");
                            }
                        }
                        communication.statsTable(true);
                        break;
                    case "sportsBookEventDetailInline":
                        $("#section").addClass("scroll-offer");
                        eventDetail.eventDetailInlineModule.eventDetailInlineRender(data);
                        events.eventsSignalrModule.setSignalR(refresh);
                        communication.statsTable(true);
                        break;
                    case "resultsEventDetail":
                        data.IsResult = true;
                    case "sportsBookEventDetail":
                        eventDetail.eventDetailRender(data);
                        if (!(pageID === "resultsEventDetail" || stored.redirectTo === "results")) {
                            events.eventsSignalrModule.setSignalR(refresh);
                            shared.scrollModule.scrollReload(pageID, "reload");
                        }
                        if (!refresh)
                            communication.statsTable(true);
                        main.dialogOpen("event");
                        break;
                    case "virtualGames":
                        // Zrusim pripadne zobrazovanie streamu
                        stream.streamEnd();
                        virtual.virtualGamesRender(data);
                        break;
                    case "lotteryGames":
                        // Zrusim pripadne zobrazovanie streamu
                        stream.streamEnd();
                        lottery.lotteryGamesRender(data);
                        break;
                    case "ticket":
                        ticket.ticketRender(data);
                        break;
                    case "ticketStatus":
                    case "ticketStatusTicketCode":
                        ticketDetail.ticketStatusRender(data);
                        break;
                    case "ticketStatusHistory":
                        ticketDetail.ticketStatusHistoryRender(data);
                        break;
                    case "myTickets":
                        player.playerTickets.myTicketsRender(data);
                        break;
                    case "playerBonuses":
                        player.playerBonusModule.playerBonusesMenuRender(data);
                        break;
                }
                setTimeout(function() {
                    if (stored.isMatchesFilterActive) $("#eventsFilter").show();
                    else $("#eventsFilter").hide();
                });
    
                if (pageID == profile.checkPage) main.unlockSB();
    
                service.loadPureUnlockBtn(refresh);
    
                modal.hideLoading();
                return true;
    
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                main.createLog(2, "BuildPageError", data + " # ERROR: " + e);
                service.loadPureUnlockBtn(refresh);
                if (offer.favSportID !== -1) {
                    $("#sportsBook").removeClass("ui-disabled");
                }
                modal.hideLoading();
                return false;
            }
    },

    // Refresh tlacitko (reload stranky)
    refreshBtn: function(event) {
    
            // Refresh Button
            $("#tableTop .rfs-ico").addClass("rfsX-ico").parents("a").addClass("lock-btn");
            if (event) $("#eventTop .rfs-ico").addClass("rfsX-ico").parents("a").addClass("lock-btn");
    
            // Aktualizuje sa event
            if (event && offer.eventID) {
                service.loadPure('sportsBookEventDetail', null, true);
                shared.scrollModule.scrollReload("sportsBookEventDetail", "clear");
            }
    
            // Aktualizuje sa ponuka
            if (offer.pointer) {
                switch (offer.pointer.substr(0, 1)) {
                    case "S":
                        service.loadPure('sportsBookRegions', null, true, -1);
                        break;
                    case "R":
                        service.loadPure('sportsBookLeagues', null, true, -1);
                        break;
                    case "F":
                        if (offer.pointer.replace(/\d/g, '') === "FA") {
                            // Reload s otvorenymi oblubenymi 1. uroven
                            service.loadPure("sportsBookRegions", "FA0", true, -1);
                        } else if (offer.pointer.replace(/\d/g, '') === "FASP") {
                            // Reload s otvorenymi oblubenymi 2. uroven
                            service.loadPure("sportsBookLeagues", offer.pointer, true, -1);
                        }
                        break;
                    default:
                        // "L" & "G" & (Otvorene oblubene "L" 3. uroven)
                        service.loadPure('sportsBookEvents', null, true, -1);
                        break;
                }
            } else {
                switch (offer.page) {
                    case "home":
                        // osetrujem refresh z modalu eventu zo zoznamu zapasov (zapasy dna) na Home obrazovke aby to neprechadzalo na kurzovu ponuku
                        break;
                    case "popularLeagues":
                        delete cache.TopOfferLeagueCups;
                        service.loadPure('popularLeagues', null, true);
                        break;
                    case "virtualGames":
                        if (offer.regionID == -1) {
                            service.loadPure('virtualGames', null, true);
                        } else {
                            service.loadPure('sportsBookEvents', null, true);
                        }
                        break;
                    default:
                        service.loadPure('sportsBook', null, true);
                        break;
                }
            }
    
            // Aktualizuje sa tiket
            ticket.ticketDelta();
    },

    // Volanie na NativeApp pred manualnym odbolokovanim SB
    manualUnblockByRVO: function() {
            main.closeDialog();
            // Popis spravania:
            // Po zavolani funkcie, nativeApp zobrazi nevyplneny formular v ktorom sa pozaduje Meno, Priezvisko, Rodne cislo hraca.
            // Po kontrole spravnosti udajov obluhou, obsluha nacita karticku obsluhy, cim udaje potvrdi
            // Hrac je overeny voci RVO a vyhladany v db cez vlc API pri pozitivnom scenary je prihlaseny pod playerID
            // V pripade ze sa nenachadza v db, hrac je prihlaseny pomocou specialneho playerID = -10 do SB
            // Z pohladu tiketovej sluzby ma tento hrac nastavene playerID = 0 tzn. jedna sa o anonymne tipovanie
            setTimeout(function() {
                try {
                    ActionManualUnblockByRVO();
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    return false;
                }
            }, 500);
    },

    // Volanie na NativeApp pred manualnym odbolokovanim SB
    manualUnblockByPlayer: function(playerID, noPlayerDataUpdate) {
            main.closeDialog();
            // Popis spravania:
            // Funkcia je relevantna pri scenary:
            // Hrac nacita neodblokovanu vernostu kartu (po zadani PINu) sa mu zobrazi okno s 3 moznostami odomknutia SB
            // Hrac ma spristupnene personalizovane Manualne odomknutie vdaka volaniu nativeApp ShowDialogActivateCard(playerID, nameAndSurname, identificationNumber) v 3. moznosti
            // Stlacenim "POKRACOVAT" sa na nativeApp zavola ManualUnblockByPlayer(playerID, true);
            // - Akcia ma za nasledok, ze v nativeApp formulary overenia hraca su predvyplnene hracske udaje, prepnuty je v 3. kroku overenia
            // - Po potvrdeni obsluhou je hrac overeny voci RVO
            // - Hrac je podla rodneho cisla vyhladany v db cez vlc API, ak existuje v db (standardne vzdy) prihlasi hraca pod playerID (je nutne zadat PIN znova)
            // Stlacenim "UPRAVIT" sa na nativeApp zavola ManualUnblockByPlayer(playerID, false);
            // - Akcia ma za nasledok, ze v nativeApp formulary overenia hraca su predvyplnene hracske udaje a prechadza vsetky kroky overovania
            // - Dalsie kroky su rovnake ako v pripade "POKRACOVAT"
            setTimeout(function() {
                try {
                    ManualUnblockByPlayer(playerID, noPlayerDataUpdate);
                } catch (e) {
                    console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                    return false;
                }
            }, 500);
    },

    // Funkcia na generovanie a zobrazenie qr kodu pre odomknutie sportboxu
    generateUnlockingQRcode: function() {
            try {
                if (kjua && stored.qrCode) {
                    var qrCodeToUnlockSB = kjua({text: stored.qrCode, size: 128, ecLevel: 'M', fill: '#000000' });
                    $("#vlcContainer .qr-code.custom").empty()[0].appendChild(qrCodeToUnlockSB);
                    return true;
                }
                $("#vlcContainer .qr-code.custom").empty();
                return false;
            } catch (e) {
                $("#vlcContainer .qr-code.custom").empty();
                return false;
            }
    },

    // Funkcia zabezpecujuca obmedzenia pri pomalom/obmedzenom pripojeni
    connectionRestrictions: function() {
            try {
                if (profile.IsStreamEnabled && !profile.IsConnectionFupEnabled) {
                    // Povolenie zobrazovania streamov
                    if (!stored.ConnectionEffectiveType) {
                        stored.AllowStream = ["4g","3g"].some(function(streamAllowedConnectionType) {
                            if (streamAllowedConnectionType === navigator.connection.effectiveType) return true;
                        });
                        stored.ConnectionEffectiveType = navigator.connection.effectiveType;
                    }
                    navigator.connection.addEventListener('change', function() {
                        if (stored.ConnectionEffectiveType !== navigator.connection.effectiveType) {
                            stored.AllowStream = ["4g","3g"].some(function(streamAllowedConnectionType) {
                                if (streamAllowedConnectionType === navigator.connection.effectiveType) return true;
                            });
                            stored.ConnectionEffectiveType = navigator.connection.effectiveType;
                        }
                    });
                }
                return true;
            } catch(e) {
                console.error(e);
                return false;
            }
    },

    // Funkcia ktora vracia string s informaciami o aktualnych parametroch pripojenia (effectiveType, rtt, downlink)
    connectionParamsString: function() {
            try {
                return " Connection params: effectiveType: "
                + navigator.connection.effectiveType
                + ", rtt: " + navigator.connection.rtt
                + ", downlink: " + navigator.connection.downlink
            } catch(e) {
                return "";
            }
    }
};
